export const applicationTitle = {
  title: 'ACM | NCR VOYIX',
  withModuleName: ' | ACM',
};

export const GRID_DIALOG_DATA = {
  title: 'Delete Entry Confirmation.',
  content: 'Press Yes to confirm entry deletion.',
};

export const SERVICE_LEVEL_DATA = {
  title: 'Service Levels',
  createTitle: 'Create Service Levels',
  updateTitle: 'Update Service Levels',
  daysSupported: 'days_Supported',
  hoursSupported: 'hours_Supported',
  orderedByTime: 'ordered_By_Time',
  onSiteComplianceTime: 'on_Site_Compliance_Time',
  service_Response_Type_Id: 'service_Response_Type_Id',
};

export const SERVICE_LEVEL_API_SUCCESS_TEXT = {
  create: 'Service level created successfully',
  update: 'Selected entry updated successfully',
  activate: 'Activation successful for selected entries',
  deactivate: 'Deactivation successful for selected entries',
  PriceSheetUpdate: 'PriceSheet saved successfully.',
  contractUpdate: 'Contract is updated successfully.',
  contractNotUpdate: 'Contract is not updated.',
  warrantyTabSaved: 'Warranty Period saved successfully.',
  warrantyTabNotSave: 'Warranty Period not saved successfully.',
  exServicesTabSaved: 'Ext. Service Period saved successfully.',
  exServicesTabNotSave: 'Ext. Service Period not saved successfully.',
  selectedOptionSave: 'Selected Options saved successfully.',
  selectedOptionNotSave: 'Selected Options not saved successfully.',
};

export const OSS_BILL_SETS_DATA = {
  title: 'Out of Scope Bill Sets',
  createTitle: 'Create Out of Scope Bill Set',
  updateTitle: 'Update Out of Scope Bill Set',
  tabRules: 'Rules',
  tabContracts: 'Contracts',
  tabOoSCases: 'OOS Cases',
  billCalcTypeDropdown: [
    { value: 1, label: 'Decimal' },
    { value: 2, label: 'Step' },
  ],
  addBillSetAdded: 'OOS Bill Set added successfully',
  addBillSetsNotAdded: 'OOS Bill Set not added, please try again',
  oosBillSetUpdated: 'OOS Bill Set updated successfully',
  oosBillSetDeleted: 'OOS Bill Set deleted successfully',
  addAlreadyExist: 'OOS  Bill Set already exist with same name',
  updateDeleteError:
    'OOS Bill Set can not be deleted as Bill Set is referred in contract.',

  BE_addAlreadyExist: 'Billset already exist with same name.',
  BE_updateAlreadyExist: 'Billset already exist with same name.',
  BE_updateDeleteError:
    'Billrules can not be deleted as Billset is referred in contract.',

  addNewRule: 'Please Add New Rule.',
  description: 'Description',
  fieldsAreManadatory: 'Indicates mandatory fields',
  country: 'Country',
  currency: 'Currency',
  serviceType: 'Service Type',
  billCalctype: 'Bill Calc Type',
  startTime: 'Start Time',
  endTime: 'End Time',
  baseQtyMin: 'Base Qty (minutes)',
  baseFee: 'Base Fee',
  incQtyMin: 'Inc.Qty (minutes)',
  incFee: 'Inc Fee',
  action: 'Action',
  samplText: 'Sample Text',
  name: 'Name',
  nameContains: 'Name Contains',
  alertMessage: 'Are you sure you want to delete?',
  create: 'create',
  update: 'update',
  billsetLimit: 24,
};

export const EPR_PRODUCT_DATA = {
  feeSave: 'Data has been Saved for Fees',
  endOfServiceSave: 'Data has been Saved for End Of Service',
  dataSave: 'Data has been saved successfully.',
  title: 'ERP Product',
  initialSelectValueForAny: 'Any',
  intdropDownDefaultValueForAny: 0,
  dropDownDefaultValueForAny: 'a',
  dropDownDefaultValueForYes: 'y',
  radioButtonWithMultipleFilters: 'Search with Multiple Filters',
  radioButtonWithProductCode: 'Search with Product Code',
  displayTitle: 'Display ERP Product',
  valueForA: 'a',
  discontinueSubModel:
    'Are you sure you want to discontinue this Product as a Submodel Product?',
  continueModel:
    'Are you sure you want to make this Product a Submodel Product?',
  erp_eos_modal_statement1:
    'The following contracts have entitlements who have been billed already for a time period extending past the new Product End of Service date of',
  erp_eos_modal_statement2:
    "When you click the 'Accept' button, all of the contracts in this listing will be saved with the Contract End of Service date set as the displayed Max next Bill Date. Please remove from this listing contracts that you do not wish to either create overrides for or update exiting end of service date.",
  serviceExceptionModalTitle: 'End of Service Exceptions',
  subModelCheckboxTitle: 'A Model must be selected for a Submodel Product.',
  toastData: 'Data has been Saved for General Info',
  toastsubmod: 'Data has been Saved for Model and SubModel',
  enterProd: 'Please enter Product Code',
  entVal: 'enterValue',
};

export const HARDWAR_CLASS_BODY = {
  searchText: '',
  pageIndex: 1,
  recordCount: 10,
};

export const E_TRACK_SETTINGS_DATA = {
  entitlementContent: {
    inputLabel: 'Default No. of days out of generate bill',
  },
  heading: 'EM/e-Track Settings',
  tab1: 'Entitlement',
  tab2: 'Sales Import',
  tab3: 'e-Track',
  tab4: 'Accounting Group',
  apiSuccessText: 'EM/e-Track Settings has been saved successfully.',
  accountingGroup: {
    uniqueIdentifier: 'name',
    accountingGroup: 'accountingGroupCode',
  },
  salesImport: {
    uniqueIdentifier: 'id',
  },
  minimumDays: -8,
  maximumDays: -60,
  apiErrorText: 'EM/e-Track Settings has not been saved.',
};

export const API_FAIL_TEXT = {
  error: 'Something went wrong',
  loginAgain: 'Session expired, please Re-Login.',
};

export const handlePending = (state) => {
  state.loading = true;
};

export const handleRejection = (state) => {
  state.loading = false;
};

export const GRID_ROW_ID = {
  serviceLevel: 'service_Level_Id',
  accountingGroup: 'accountingGroupCode',
  countryGroup: 'countryId',
  customerGroup: 'customerId',
  siteGroup: 'id',
  billToGroup: 'id',
  warranty: 'warrantyId',
  warrantyNew: 'newRowId',
  contract: 'contractId',
  priceSheetGrid: 'rowNumber',
  priceClassGrid: 'price_Class_Id',
  warrantyHistory: 'effectiveDate',
  warrantyEntitlement: 'entitlementId',
  billClassGrid: 'bill_Class_Id',
  billStatusId: 'billStatusId',
  customerBillId: 'customerBillId',
  eTrackSettings: {
    accountingGroup: 'name',
  },
  pricingNoteId: 'pricing_Note_Id',
  servicePriceOffering: 'service_Price_Level_Id',
  oosBillSetsSearch: 'bill_set_id',
  approvalGrid: 'contractId',
  defferalPriceSheet: 'priceClassId',
  logistcsPriceSheet: 'priceClassId',
  salesMapping: {
    orderable: 'erpServiceProductId',
    unsupported: 'salesProductId',
  },
  customers: 'customerId',
  customerHistory: 'id',
  contractNotes: 'contractNoteId',
  noteTypeId: 2,
  warrantyExtendeed: {
    serviceId: 'unId',
    priceId: 'id',
  },
  orderNumber: 'orderNumber',
  siteActivityGrid: 'rowNumber',
  customerNotes: 'customer_Note_Id',
  siteSalesOrder: 'order_Number',
  entitlementsSiteHistory: 'siteId',
  rowIndex: 'rowIndex',
  entitlementsGlobalCustomerGrid: 'customerId',
  caseId: 'caseId',
  caseStatus: 'caseStatus',
  caseOOSItem: 'chargeCode',
  caseOOSHistory: 'effectiveDate',
  supported: 'erpSalesProductId',
  entitlementHistory: 'serviceLevelId',
  entitlementNotes: 'entitlementNoteId',
  entitlementsSearchDataGrid: 'entitlementId',
  oosCaseNotes: 'radOOSCaseNoteID',
  entitlementProductHistoryGrid: 'productCode',
  siteentitlementDetailsGrid: 'EMID',
  salesOrderCustomer: 'orderNumber',
  customerProductSummaryGrid: 'serviceProductCode',
  customerSitesGrid: 'psSiteCode',
  entitlementsSiteActivityGrid: 'siteActivityId',
  siteActivityDetailEntitlementsGrid: 'entitlementId',
  erpSalesOrderItemsMasterCustomerNumberGrid: 'customerId',
  transferDetailEntitlementsGrid: 'entitlementId',
  erpSalesOrder: {
    productSearchId: 'id',
  },
  serviceModalGrid: 'erpModelId',
  billingToolBOCGridId: 'globalCustomerId',
  billingDetailsTabId: 'tempId',
  zonePriceClass: 'priceClassId',
  productId: 'productId',
  erpSalesOrderItemId: 'erpSalesOrderItemId',
  salesInfoTab: 'contractId',
  uniqueIdentifier: 'idx',
};

export const GRID_VARIANT = {
  multiple: 'multiple',
  table: 'table',
  standard: 'standard',
  singleClickSelection: 'singleClickSelection',
  noSelection: 'noSelection',
  rowClick: 'RowClick',
};

export const GRID_ROWS_PER_PAGE = {
  cpi: 100,
  default: 25,
  history: 25,
  serviceLevel: 25,
  accountingGroup: 25,
  countryGroup: 25,
  warranty: 25,
  customerGroup: 25,
  billToGroup: 25,
  siteGroup: 25,
  priceSheetGrid: 25,
  priceClassGrid: 25,
  contractsGrid: 25,
  billClassGrid: 25,
  autocomplete: 10,
  initialVal: 0,
  initialIndex: 1,
  erpProduct: 25,
  eTrackSettings: 25,
  approvalGrid: 25,
  serviceProductCode: 25,
  customers: 25,
  salesMapping: 25,
  priceClassesSearch: 25,
  pricesTable: 25,
  logisticsServiceTable: 500, //If needed that is to be made dynamic as per deferral
  oosBillSets: 25,
  rowsPerPageOptions: [25, 50, 100],
  eTrackRowsPerPageOptions: [25, 50, 100],
  siteActivityGrid: 25,
  entitlementsSiteHistoryGrid: 25,
  entitlementsSearchGrid: 25,
  entitlementsGlobalCustomerNumberGrid: 25,
  summary: 100,
  outOfScopeCases: 25,
  entitlementHistoryGrid: 25,
  entitlementsServiceProductGrid: 25,
  entitlementNotesGrid: 25,
  entitlementsSearchDataGrid: 25,
  siteEntitlementDetailsGrid: 25,
  entitlementSiteActivityGrid: 25,
  siteActivityDetailEntitlementsGrid: 25,
  sitesSiteActivityGrid: 25,
  siteSearch: 25,
  erpSalesOrderItemsSearchGrid: 25,
  erpSalesOrderProductSearchGrid: 25,
  erpSalesOrderItemsGlobalCustomerNumberGrid: 25,
  orderGroup: 25,
  erpSalesOrderSummary: 25,
  serviceProductModal: 25,
  maxOOSBillsets: 25,
  erpSalesOrderLineItemGrid: 25,
  erpSalesOrderLineItemProductGrid: 25,
  priceClass: 25,
  erpProductSearchGrid: 25,
  serviceLevelGrid: 25,
  eTrackQuoteGridData: 25,
  customersBillingBillNotesGrid: 25,
  contractOOSLaborFeesGrid: 25,
  contractOOSHardwareFeesGrid: 25,
  contractOOSHardwareLogisticsGrid: 25,
  entitlementBillingActivityCPI: 25,
  billingActivityBillingGrid: 25,
  serviceOffering: 25,
  eTrackDetails: 25,
  eTrackExistingQuotes: 25,
  eTrackSearchGrid: 25,
  relatedContractsGrid: 25,
  auditTrailGrid: 25,
  eTrackSearchSourceGrid: 25,
  eTrackQuoteApprovalEntitlementGrid: 25,
  customRowsGrid: 10, //to show 10 rows in custom grid
};

export const GRID_INITIAL_MESSAGE = {
  serviceLevel: 'Please Select a Name',
  erpProduct: 'Please Select a Name',
  loading: 'Loading...',
};

export const GRID_NO_DATA_FOUND_MESSAGE = {
  default: 'No Result Found',
  noData: 'No data Available',
  unsupported: 'No Data Found',
};

export const WARRANTIES_DATA = {
  candidate: ' Candidate Serial Number for Swap',
  title: 'Warranties',
  serialNoText: 'Serial No Contains',
  warrantyPartText: 'Warranty Part No.',
  displayTitle: 'Display',
  display: 'Display Warranty',
  historyHeader: 'Serial number history for warranty ',
  entitlementHeader: 'Entitlement(s) referencing this warranty',
  dateCreated: 'Date Created',
  lastUpdatetd: 'Last Updated',
  serialNumberRadio: 'serialNumberRadio',
  warrantyPartNumberRadio: 'warrantyPartNumberRadio',
  search: 'Search',
  currentSerialNumber: 'serialNumber',
  warrantyPartNumber: 'warrantyPartNumber',
  enter: 'Enter part no for search...',
  wnError: 'Please enter numeric value',
  snError: 'Please enter serial no',
  currentSrInfo: 'Current Serial Number Information',

  gridColumnLableStartDate: ' Warranty Start Date',
  gridColumnLableDuration: 'Duration',
  gridColumnLableType: 'Type',
  gridColumnLableDeferralFee: 'Deferral Fee',

  gridColumnLableEffectiveDate: 'Effective Date',
  gridColumnLableSerialNo: 'Serial No.',
  gridColumnLableModel: 'Model',
  gridColumnLableSubmodel: 'Submodel',
};

export const BUTTON_TEXT = {
  ignoreAll: 'Ignore All',
  resetCPITable: 'Reset CPI Table',
  go: 'Go',
  updateAll: 'Update All',
  refresh: 'REFRESH',
  reset: 'RESET',
  cancel: 'CANCEL',
  display: 'DISPLAY',
  search: 'SEARCH',
  history: 'REFRESH HISTORY',
  create: 'CREATE',
  update: 'UPDATE',
  lockdown: 'LOCKDOWN',
  activate: 'ACTIVATE',
  deactivate: 'DEACTIVATE',
  createNew: 'CREATE NEW',
  backToSearch: 'BACK TO SEARCH',
  approvalQueue: 'APPROVAL QUEUE',
  saveAndClose: 'SAVE & CLOSE',
  addAndClose: 'Add & CLOSE',
  save: 'SAVE',
  print: 'PRINT',
  submitForApproval: 'Submit for approval',
  copyPriceSheet: 'COPY PRICE SHEET',
  copyContract: 'Copy contract',
  removeitem: ' REMOVE ITEM',
  add: 'ADD',
  close: 'CLOSE',
  exit: 'EXIT',
  remove: 'REMOVE',
  addNew: 'ADD NEW',
  edit: 'Edit',
  hide: 'Hide Search Options',
  show: 'Show Search Options',
  modify: 'MODIFY',
  approved: 'APPROVED',
  submitted: 'SUBMITTED',
  associate: 'ASSOCIATE SERVICE PRODUCT/LEVEL ',
  associateSalesProduct: 'ASSOCIATE SALES PRODUCT',
  viewResult: 'VIEW RESULTS',
  eTRACK: 'eTRACK',
  delete: 'DELETE',
  addNewRule: 'ADD NEW RULE',
  continue: 'CONTINUE',
  searchSalesOrderStaging: 'Search order from Staging',
  searchSalesOrder: 'Search ERP SALES order',
  manualPurchaseOrder: 'Manual Purchase order',
  hideContract: 'Hide Contract details',
  showContract: ' Show Contract details',
  backToContracts: 'BACK TO CONTRACTS',
  tempAdd: 'TEMP ADD',
  backToCustomers: 'BACK TO CUSTOMERS',
  backToChildCustomers: 'BACK TO CHILD CUSTOMER',
  backToEntitlements: 'BACK TO ENTITLEMENTS',
  transfer: 'TRANSFER',
  hideEntitlementSearch: ' Entitlement Search Options',
  backToOOSCases: 'BACK TO OUT OF SCOPE CASES',
  batchUpdate: 'BATCH UPDATE',
  addOOSItem: 'ADD OOS ITEM',
  updateStatus: 'UPDATE STATUS',
  showIcon: 'Show Icon',
  hideIcon: 'Hide Icon',
  copy: 'COPY',
  viewBackup: 'View Backup',
  crateEntitlement: 'Create Entitlement',
  resetLine: 'Reset Line',
  ok: 'OK',
  APPROVE_QUOTE: 'APPROVE QUOTE',
  SUBMIT: 'SUBMIT',
  REQUEST_EMAIL_COPY: 'REQUEST EMAIL COPY',
  QUOTE_EXPORT_CLIENT: 'Quote export for client',
  QUOTE_EXPORT_RESELLER: 'Quote export for reseller',
  EXPORT_TO_XLS: 'EXPORT TO EXCEL',
  downloadBills: 'Download Bills',
  regenerateBills: 'Regenerate Bill',
  approveBills: 'Approve to Bill',
  returnToWaititng: 'Return to Waiting',
  restore: 'RESTORE',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  etrackAddSelection: 'Add selected item to quote',
  etrackAllSelection: 'Select all',
  etrackAllDeSelection: 'unselect all',
  etrackCreateQuote: 'Create Quote',
  etrackRemoveSelection: 'Remove selected from the list',
  returnToWait: 'Return To Waiting',
  billedBtn: 'Billed',
  view: 'View',
  generateBill: 'Generate Bill',
  select: 'SELECT',
  checkAllForPage: 'Check All for Page',
  uncheckAllForPage: 'Uncheck All for Page',
  addItems: 'Add Items',
  deleteSelected: 'Delete Selected',
  selectAll: 'Select All',
  unSelectAll: 'Unselect All',
  syncSite: 'Sync a Site',
  existingQuotes: 'Existing Quotes',
  accept: 'ACCEPT',
  checkForAllListing: 'Check All for Listing',
  uncheckForAllListing: '  Uncheck All for Listing',
  returnToCreate: 'Return to Create',
  openSmartSheet: 'Site Add/Change',
  updateContracts: 'Update',
  addCustomer: 'Add Customer',
  change: 'Change',
};

export const CHECK_BOX_VALUE = {
  Yes: 'Yes',
  yes: 'y',
  no: 'n',
  any: 'any',
  No: 'No',
};

export const PRICING_DATA = {
  totalPriceClassFound: 'Total Price Class Found:',
  title: 'Price Book',
  searchPriceClassModalTitle: 'Search Price Class',
  priceSheetText: 'PRICE SHEET',
  priceClassessText: 'PRICE CLASSES',
  billClassessText: 'BILL CLASSES',
  errorCommon: 'Something went wrong. Please try again.',
  errorAlert: 'You must first Specify Country, Effective Date, Pricing Type!',
  errorAlertExist:
    'A price sheet matching your options already exists. Click OK to open that price sheet.',
  modalCountryTitle: 'Country',
  modalAccountingGroupTitle: 'Accounting Group',
  stringValues: 'string',
  price: 'Pricing',
  notes: 'Notes',
  auditTrail: 'Audit Trail',
  deferralpricebook: 'Deferral Price Book',
  deferralpriceSheet: 'Deferral Price Sheet',
  standardlogisticspriceSheet: 'Standard Logistics Price Sheet',
  inputVarient: 'modalInput',
  modalBillClassTitle: 'Bill Class Search',
  addBillClassSuccessMsg: 'Bill Class added successfully',
  exstingDataMsg:
    'A price sheet already exists. Select any record from the grid.',
  existingPriceSheetMsg:
    'A price sheet matching your options already exists. Click OK to open that price sheet.',
  searchOptions: 'SEARCH OPTIONS',
  priceClass: 'Price Class',
  total: 'Total',
  totalPriceSheetFound: 'Total price sheet found: ',
  removeBillClassSuccessMsg: 'Selected Bill Class Removed Successfully',
  priceNotes: 'You have not added any notes!',
  priceNotesText: 'Please add a new note to the price sheet.',
  backToPriceSheet: 'Back to Price sheet',
  viewPriceSheet: 'View Price sheet',
  createPriceSheet: 'Create Price sheet',
  withinlist: 'withinlist',
  withinlistMsg: 'WITH IN THE LIST',
  mcDonald: 'MC Donald',
  createNewContract: 'Create New Contract',
  cancelPriceSheet: 'Cancel the working price sheet',
  PriceClassaAlreadyExists: 'Price class already exists.',
  serviceOfferingAleradyExists: 'Service Offering already exists.',
  noofServiceOfferingCOuntText: 'No. of Service offerings: ',
  pricingTypeId: {
    StandardDeferral: 1,
    StandardLogistics: 2,
  },
  priceBookTabs: {
    PriceSheet: 0,
    PriceClasses: 1,
    BillClasses: 2,
  },
  noteTypeId: {
    deferralAuditTrail: 1,
    deferralNotes: 2,
  },
  logistcsPriceSheetPriceClassId: 1,
  logisticpriceSheetId: 500087,
  servoceOfferingFoundMsg: 'No. of Service offerings found: ',
  pricingTypeIdConst: 2,
  copyPriceSheetModalTitle: 'Copy Price Sheet',
  errorcopyPriceSheetAlertExist:
    'Price sheet exists with these exact details. Are you sure you want to copy this pricing to the selected price sheet? This cannot be undone.',
  copyPriceSheetDestinationTitle: 'Destination Price Sheet',
  copyPriceSheetSourceTitle: 'Source Price Sheet',
  errorAlertCountry: 'Please select the destination country.',
  errorAlertDuplicateCountry:
    'The source and destination countries cannot be the same. Please select a different destination country.',
  errorEffectiveDate:
    'Please select effective date for destination price sheet.',
  notificationCopyPriceSheetEmail:
    'You would be notified via email once the price sheet is copied.',
};

export const COMMON_DROPDOWN_OPTIONS = {
  yes_no_options: [
    {
      value: 'y',
      label: 'Yes',
    },
    {
      value: 'n',
      label: 'No',
    },
  ],
  any_yes_no_options: [
    {
      value: 'a',
      label: 'Any',
    },
    {
      value: 'y',
      label: 'Yes',
    },
    {
      value: 'n',
      label: 'No',
    },
  ],
  noChange_yes_no_options: [
    {
      value: 'y',
      label: 'Yes',
    },
    {
      value: 'n',
      label: 'No',
    },
  ],
  import_status_options: [
    {
      value: '<>',
      label: '<>',
    },
    {
      value: '=',
      label: '=',
    },
  ],
  importstatus_operators: [
    {
      value: '<>',
      label: '<>',
    },
    {
      value: '=',
      label: '=',
    },
  ],
  anyYNOptions: [
    {
      value: 'y',
      label: 'Y',
    },
    {
      value: 'n',
      label: 'N',
    },
  ],
  ynAnyOptions: [
    {
      value: 'a',
      label: 'Any',
    },
    {
      value: 'y',
      label: 'Y',
    },
    {
      value: 'n',
      label: 'N',
    },
  ],
};

export const COMMON_MESSAGE = {
  select: 'Please Select',
  any: 'Any',
  noData: 'No Data Found',
  yes: 'y',
  no: 'n',
  Yes: 'Yes',
  No: 'No',
  active: 'Active',
  deactive: 'Deactive',
  search: 'Search',
  enter: 'Enter',
  none: 'None',
  noneWithBracket: '[None]',
  initialSelectValueForAny: 'Any',
  dropDownDefaultValueForAny: 'a',
  dropDownDefaultValueForYes: 'y',
  selectOnly: 'Select',
  intitialSelectForZeor: 0,
  unsavedMsgAlert:
    'You have unsaved changes. Leaving this page will discard them. Do you want to save?',
  resetUnsavedMsgAlert:
    'You have unsaved changes. Resetting this will discard them. Do you want to save?',
  searchUnsavedMsgAlert:
    'You have unsaved changes. Search will discard them. Do you want to save?',
  anySite: '[Any]',
  anySiteId: 0,
  wrongErrorCommon: 'Something went wrong. Please try again.',
};

export const BILL_CLASS = {
  any: 'Any',
  name: 'name',
  defaultDate: '0001-01-01T00:00:00',
  hide: 'Hide Search Options',
  show: 'Show Search Options',
  count: 'Total Count:',
  errorAlert: 'Remove a Bill Class',
  errorAlertContent:
    'Are you sure you want to remove selected bill class permanently?',
  modaltitle: 'Add a New Bill Class',
  description: 'Description',
  label: 'Name of Price Class',
  totalBillClass: 'Total Bill Class:',
  totalBillClassFound: 'Total Bill Class:',
  nameOfBillClass: 'Name of Bill Class',
  searchByDescription: 'Search by Description',
};

export const DISPLAY_DATE_FORMAT = {
  en_usFormat: 'en-US',
};

export const DATE_PICKER_VARIANT = {
  standard: 'standard',
  dateTime: 'dateTime',
  desktop: 'desktop',
};

export const DATE_PICKER_FORMAT = {
  esUSdateTime: 'MM/dd/yyyy hh:mm:ss a',
  dayMonthYearWithTime: 'MM/DD/YYYY | hh:mm:ss A',
  dayMonthYear: 'MM/dd/yyyy',
  dayMOnthYearFormat: 'MM/DD/YYYY',
};

export const TIME_PICKER_FORMAT = {
  onlyHours: 'hh:00 A', // i.e. 12:00 AM, 01:00 AM, 12:00 PM, 01:00 PM
  hoursMinutesSeconds: 'hh:mm:ss',
};

export const DATE_PICKER_VIEW = {
  dateTimeSeconds: ['year', 'day', 'hours', 'minutes', 'seconds'],
  yearMonthDay: ['year', 'month', 'day'],
};

export const REGEX = {
  numeric:
    /^(([0-9]{0,9})|1[0-9]{9}|20[0-9]{8}|(21[0-3][0-9]{7})|(214[0-6][0-9]{6})|(2147[0-3][0-9]{5})|(21474[0-7][0-9]{4})|(214748[0-2][0-9]{3})|(2147483[0-5][0-9]{2})|(21474836[0-3][0-9])|(214748364[0-7]))$/,
  onlyNumber: /[^0-9]/g,
  numericWithDash: /[^0-9-]/g,
  numberWithDot: /[^0-9.]/g,
  numericWithDot: /^\d*(\.\d*)?$/,
  alphabets: /[^a-zA-Z]/g,
  specialCharacterWthoutUnderScore: /[!@#$%^&*()+{}[\]:;<>,.?~\\/\-=]/g,
  alphabetsOnly: /^[a-zA-Z ]+$/g,
  initialBlankSpace: /[^A-Za-z0-9-,.;'&/.() ]|^/g,
  alphabetsWithSpace: /[^a-zA-Z\s]/g,
  alphanumericwithhyphen: /^[a-zA-Z0-9-]*$/,
  alphanumeric: /^[a-zA-Z0-9]*$/,
  daysOutRegex: /(?:\()?-?(\d+(\.\d+)?)(?:\))?/,
  alphabetsWithNo: /[^a-zA-Z0-9]/g,
  onlyNumberWithoutDot: /^[0-9\b]+$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

export const REDIRECT_URL = {
  home: '/home',
};

export const BUTTON_VARIANT = {
  contained: 'contained',
  standard: 'standard',
  outlined: 'outlined',
  reset: 'reset',
  cancel: 'cancel',
  backToSearch: 'backToSearch',
  copy: 'copy',
  add: 'add',
  print: 'print',
  export: 'export',
  view: 'eye',
};

export const BUTTON_COLOR = {
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  error: 'error',
  grey: 'grey',
};

export const DATA_PER_PAGE = {
  priceSheet: 50,
  priceClass: 50,
  billClass: 25,
};

export const PAGINATION = {
  rowsPerPageText: 'Rows per page',
  billClass: 350,
  serviceLevel: 100,
  customDefaultRowsPerPage: 10,
  defaultRowPerPage: 25,
  items: 'items',
  item: 'item',
  goToPage: 'Go to page:',
};

export const PAGE_INITIAL_NUMBER = {
  serviceLevel: 1,
};

export const LABEL_TEXT = {
  mandatory: 'Indicates mandatory fields',
};

export const LABEL_VARIANT = {
  mandatory: 'mandatory',
};

export const MODAL_VARIANT = {
  small: 'small',
  large: 'large',
  medium: 'medium',
  //Add Custom Modal With variant name
  m600: 'm600',
  m750: 'm750',
  m950: 'm950',
};

export const PRICE_OPTIONS_DEFAULT_TAB = [
  {
    contractZoneName: 'Deferral',
    contractZoneId: 5,
    contractZoneNameDisplay: 'Deferral',
  },
  {
    contractZoneName: 'Rental',
    contractZoneId: 6,
    contractZoneNameDisplay: 'Rental',
  },
  {
    contractZoneName: 'Zone 1',
    contractZoneId: 1,
    contractZoneNameDisplay: 'Price Option 1',
  },
  {
    contractZoneName: 'Zone 2',
    contractZoneId: 2,
    contractZoneNameDisplay: 'Price Option 2',
  },
  {
    contractZoneName: 'Zone 3',
    contractZoneId: 3,
    contractZoneNameDisplay: 'Price Option 3',
  },
];

export const CONTRACTS_DATA = {
  HWF_updatedSuccessfully: 'Hardware Fee is updated successfully.',
  HWF_NotUpdatedSuccessfully: 'Hardware Fee is not updated.',
  HWL_updatedSuccessfully: 'Hardware Logistics is updated successfully.',
  HWL_NotUpdatedSuccessfully: 'Hardware Logistics is not updated.',
  nonStCF_updatedSuccessfully:
    'Non-Standard Consumable Fees is updated successfully.',
  nonStCF_NotUpdatedSuccessfully:
    'Non-Standard Consumable Fees is not updated.',
  SP_RemoveSuccessfully: 'Sales Product removed succsessfully',
  SP_NotRemoveSuccessfully: 'Something went wrong while removing Sales Product',
  title: 'Contracts',
  contractsLabel: 'Contracts ID',
  archievedTitle: 'Archived Contract: ',
  approvalTitle: 'Approval Queue',
  inputModalDefaultVal: 'Any',
  inputModelDefaultValue: 'a',
  modalAccountingGroupTitle: 'Accounting Group',
  accountingModalInputText: 'Accounting Group Name Contains',
  modalCountryTitle: 'Country',
  modalCustomerTitle: 'Customer',
  modalBillToTitle: 'Bill To',
  modalSiteTitle: 'Sites',
  stringValues: 'string',
  inputVariant: 'iconInput',
  selectedOption: 'Selected Options',
  warrantyPeriod: 'Warranty Period',
  exServicePeriod: 'Ext. Service Period',
  extendedServicePeriod: 'Extended Services Period',
  salesMapping: 'Sales Mapping',
  relatedContracts: 'Related Contracts',
  history: 'History',
  notes: 'Notes',
  auditTrail: 'Audit Trail',
  auditTrailNoteId: 1,
  quickSearchTitle: 'Quick Search',
  existingPriceClass: 'Price Class',
  deferral: 'Deferral',
  rental: 'Rental',
  zone1: 'Zone 1',
  zone2: 'Zone 2',
  none: 'None',
  addNewContractHeading: 'Create New Contract',
  salesMappingTab: {
    orderable: 'ORDERABLE',
    supported: 'SUPPORTED',
    unsupported: 'UNSUPPORTED',
    salesOrder: 'SALES ORDER',
  },
  parentPsCustomerCode: 'parentPsCustomerCode',
  accountingGroupName: 'accountingGroupName',
  shortName: 'shortName',
  contractStatus: 'Create',
  siteNumber: 'siteNumber',
  duplicateContractMsg: 'Duplicate Contract',
  recordSubmitted: 'Record submitted successfully',
  failedRecord: 'Record submission failed',
  alertMessageNSDFirst: 'You must populate the Non-Standard Deferral first.',
  alertMsgNonStdDuration:
    'Please fill in the required field Non-Std. Duration(Months).',
  alertMsgAdditionalFee:
    'You must have either a Standard Deferral or Non-Standard Deferral to enter an Additional Fee.',
  extendedWarrentity: {
    addPriceClassText:
      ' Search and add for existing Price Class to display relevant service offerings.',
    addPriceClassButtonText: 'ADD PRICE CLASS',
    pricingOption: 'Pricing Option',
    pricingOptionOne: 'Pricing Option 1',
    pricingOptionTwo: 'Pricing Option 2',
    pricingOptionThree: 'Pricing Option 3',
    alertText:
      'Maximum number of Pricing Options reached 10. Cannot add more Pricing Options.',
    priceClass: 'Price Class',
    deferralPriceClassText:
      'The price class you have selected does not have the base deferral  ',
    deferralText:
      '  established. Please set up the deferrals for this price class before adding to the contract.',
    deferralAlertPriceClass: 'NBD PO',
    deferralPriceSheet: 1,
    contractZoneIdOne: 1,
    contractZoneIdSix: 6,
    contractFeeTypeId: 2,
    contractZoneId: 1,
    selectededTabValueOne: 1,
    selectededTabValueTwo: 2,
    seasonalZoneId: 4,
    deferralZoneId: 5,
    rentalZoneId: 6,
    maxZoneId: 13,
    warrantyPeriodFeeTypeId: 1,
    extServicePeriodFeeTypeId: 2,
    priceOption_ZoneId_1: 1,
    priceOption_Tab_No_2: 2,
    serviceOffering_5X9_NBD_PO: 1,
    warrantyPeriodTab: 1,
    priceOptionTabName: 'Price Option ',
    zone: 'Zone ',
    serviceOfferings: 'Service Offerings',
    calculatedFee: 'Calculated Fee',
    nonStdDeferral: 'Non-Standard Deferral',
    nonStdDefDuration: 'Non-Std Def. Duration (Months)',
    stdDefFee: 'Standard Deferral Fees',
    additionalFee: 'Additional Fee',
    priceClassAlreadyAdded:
      ' The price class you chose already exists on this contract. Please select a different price class.',
    areYouSure_1: 'Are you sure that you want to remove ',
    areYouSure_2:
      'from this contract? This action cannot be undone. Click OK to remove',
    priceClassCount: 999,
    baseSeriveOfferingAlert:
      'The base service offering must have an annual fee. Click OK to set this fee to $0.00. Cancel to revert to previous value',
  },
  defaultTabId: 0,
  historyTabId: 6,
  selectedOptionsTab: {
    selectedPriceClassText: 'Select a Price Class to view details',
    priceClassSelection: 'PRICE CLASS SELECTION',
    priceClassOption: 'PRICE CLASS OPTIONS',
    duration: 'Duration (Months)',
    extendedDuration: 'Extended Service Duration (Months)',
    other: 'Other',
    general: 'General',
    billing: 'Billing',
    warranty: 'Warranty',
    etrack: 'eTrack',
    oos: 'OOS',
    cpi: 'CPI',
    eTrackAccess: 'eTrack access',
    ExpiredItemsSearchLimit: 'Expired items search limit (years)',
    ExpiredItemsImportLimit: 'Expired items import limit (years)',
    ContractIDToSyncPricing: 'Contract ID to Sync Pricing',
    retailOf: '% of Retail',
    UseOfRetail: 'Use of % Retail',
    ContractDatesStart: 'Contract Start Date',
    ContractDatesEnd: 'Contract End Date',
    TransferHWOnDeactivate: 'Transfer HW on deactivate',
    support: 'Support',
    sTechAvailable: 'S-Tech Available',
    cTechAvailable: 'C-Tech Available',
    defaultSitePriceOption: 'Default Site Price Option',
    deferralCountry: 'Deferral Country',
    billDayOut: 'Bill # Days out',
    billingException: 'Billing Exception',
    exceptionNotes: 'Exception Note',
    prepayment: 'Prepayment',
    prepaymentDays: 'Default Duration',
    maxError: 'Min value cannot be greater than max value',
    minError: 'Max value cannot be less than min value',
    autoBill: 'Auto Bill',
    billSupportOnHwCases: 'Bill Support on HW cases',
    nonStandardOOSFees: 'Non-Standard OOS fees',
    laborBillSets: 'Labor Bill Sets',
    durationInMonths: 'Duration (in Months)',
    newForNew: 'New for New',
    standard: 'Standard',
    installDelay: 'Install Delay',
    autoInstall: 'Auto Install',
    useStandardDeferrals: 'Use Standard Deferrals',
    deferrals: 'Deferrals',
    currencyIsRequired: 'Currency is required',
    billCycleIsRequired: 'Bill cycle is required',
    approvedStatus: 'Approved',
    submittedStatus: 'Submitted',
    calculatedFee: 'Calculated Fee',
    annualFee: 'Annual Fee',
    serviceOffering: 'Service Offering',
    priceOption: 'Price Option',
    feeType: 'Fee Type',
    selectedDeffServiceOffering: {
      serviceOfferingId: 1,
      serviceOfferingName: '5x9 NBD PO',
    },
    errorPopup: 'Contract End Date can not be less than Contract Start Date',
    errorPopupGreat:
      'Contract Start Date can not be greater than Contract End Date',
    cycleIdAlertText:
      'Bill Cycle must be filled in before you can save the contract.',
    daysOutAlertTextMessage:
      'Bill # Days out entry is invalid. Please enter a value of type: Number.',
  },
  contractHistoryTab: {
    status: 'Status',
    CPI: 'CPI',
    returnToCreate: 'Return To Create',
    modify: 'Modify',
    create: 'Create',
    user_Id: 0,
    last_Modified_User_Id: 0,
    contractStatusId_1: 1,
    contractStatusId_2: 2,
  },
  billToNameContains: 'Bill To Name Contains',
  billToName: 'Bill To Name',
  billToId: 'Bill To Id',
  eos: ' Override EoS Date',
  supportedZoneGrid: {
    feeAndZoneInfo: 'feeAndZoneInfo',
    serviceLevelName: 'serviceLevelName',
    annualFee: 'annualFee',
    calculateAnnualFee: 'calculateAnnualFee',
    pricingOption: 'Year - Pricing Option',
    serviceLevel: 'Service Level',
    annual: 'Annual Fees',
    calculated: 'Calculated Fees',
  },
  dateErrorMsg: 'End date cannot be earlier than start date',
  timeErrorMsg: 'End time cannot be earlier than start time',
  invalidEndDateErrorMsg: 'Invalid end date',
  invalidStartDateErrorMsg: 'Invalid start date',
  zeroValue: '$00.00',
  goToBillsets: '/setup/OOSBillSets',
  statusModify: 'Modify',
  statusCreate: 'Create',
  relatedContractsTab: {
    tabTitle: 'Related Contracts',
  },
  outOfScopeTab: {
    tabId: 3, //Need to change if tab id is changed
    archivedTabTitle: 'Out Of Scope',
    chkarchivedTabTitle: 'Out Of Scope Archived',
    tabTitle: 'Out Of Scope',
    //Accordion Titles
    helpDeskLaborFeesTitle: 'Help Desk / Labor Fees',
    hardwareFeesTitle: 'Hardware Fees',
    hardwareLogisticsTitle: 'Hardware Logistics',
    isBillingSiteCheck: 'Billing Site',
    isCustomerLvlDiffCountryCheck: 'Customer Level diff Country',
    isSiteWithBillingSiteCheck: 'Site with Billing Site',
    isSiteWithoutBillingSiteCheck: 'Site without Billing Site',
    isCountryCheck: 'Country',
    isCustomerCheck: 'Customer',
    outOfScopeExpandLevel: 'outOfScopeExpandLevel',
    defaultCountryId: 236, //USA
    defaultPriceClassId: 1, //Logistics
    approvedStatus: 'Approved',
    submittedStatus: 'Submitted',
    hardwareFeesGrid: 'fees',
    hardwareLogisticsGrid: 'logistics',
    gridSaveAlert:
      'There are unsaved changes on this page. Do you want to Save it?',
    apiSuccessText: 'Out of Scope Bill Set added successfully',
    isSaveHwFees: 'isSaveHwFees',
    isSaveHwLogisticsFees: 'isSaveHwLogisticsFees',
    isSaveHwLogisticsConumableFees: 'isSaveHwLogisticsConumableFees',
  },
  contractsSearchOptions: 'Contracts Search Options',
  maxRecords: 99,

  radioButtonWithMultipleFilters: 'Search with Multiple Filters',
  radioButtonWithContractNo: 'Search with Contract No.',
  contractNumberLabel: 'Contract Number',
  contractNumberPlLabel: 'Enter Contract Number',
  warningMessage: 'Please enter Contract Number',

  notFound: 'Data not found for ',
  forId: 'Contract Number.',
  approvedStatus: 'Approved',
  createStatus: 'Create',
  submittedStatus: 'Submitted',
  modifyStatus: 'Modify',
  defaultValNone: '[None]',
  defaultValNoneValue: 0,
  alertTextMessage: 'Something went wrong. Please try again.',
  unsupportedDelete: {
    alertTitle:
      'Are you sure you want to remove this Sales Product as unsupported for this Customer?',
  },
  salesOrder: {
    highHeading: 'Sales lines that mapped at a higher contract',
    salesHeading: 'Sales lines that mapped using this contract',
  },
  copyContract: {
    back: 'BACK',
    contract: 'Contract',
    destinationContract: 'Destination Contract',
    accountingGroup: 'Accounting Group',
    country: 'Country',
    customer: 'Customer',
    billTo: 'Bill To',
    site: 'Site',
    fees: 'Fees',
    pricing: 'Pricing',
    priceClass: 'Price Classes',
    serviceOfferingFee: 'Service Offering Fees',
    hardwareMap: 'Hardware Map',
    oderableHw: 'Orderable HW',
    oderableHardware: 'Orderable Hardware',
    supportedHw: 'Supported HW',
    supportedSalesPoduct: 'Supported Sales Product(s)',
    unsupportedHw: 'Unsupported HW',
    unsupportedSalesProduct: 'Unsupported Sales Product(s)',
    copyContract: 'Copy Contract',
    itemToCopy: 'Item To Copy',
    sourceContract: 'Source Contract',
    successMessage: 'Copying contract has completed successfully',
    copyContractAlert: 'Please Add Destination Contract',
    confirmationMsg:
      'A background job has been submitted to copy this contact. You will receive an email notifying you when this job has completed.',
    copySameContractAlertMsg:
      'Source and destination contract should not be same.',
  },
  approvalAlerMessage: 'You must select at least 1 contract to approve.',
  approveButton: 'Approve',
  actionNotes: 'Action Note',
  contractApproved: 'Contract/s approved successfully',
  contractNotApproved: 'Contract is not approved',
  contractId: 'Contract ID',
  status: 'Status',
  userName: 'User Name',
  timeStamp: 'Timestamp',
  comment: 'Comments',
  trickleAlert:
    'Are you sure you want to approve all the selected contract? In doing so, all selected actions will be trickled down to the affected entitlements.Click OK to Continue, or Cancel to Abort.',
  deleteAlert:
    'Are you sure you wish to remove this Sales Product? Click Ok to Remove the Sales Product.',
  gridAlert: 'You have unsaved changes in the Table. Do you want to save?',
  gridDeleteAlert: 'Do you want to delete the mapping?',
};

export const CUSTOMERS = {
  title: 'Customers',
  initialSelectValueForAny: 'Any',
  dropDownDefaultValueForAny: 'a',
  dropDownDefaultValueForYes: 'y',
  radioButtonWithMultipleFilters: 'Search with Multiple Filters',
  radioButtonWithGlobalCustomerNo: 'Search with Global Customer No.',
  displayTitle: 'Bill to Customer',
  tabInfo: 'Info',
  tabCustomerHistory: 'Customer History',
  tabSites: 'Sites',
  tabEntitlementsSummary: 'Entitlement Summary',
  tabSalesOrders: 'Sales Orders',
  tabChildren: 'Children',
  tabNotes: 'Notes',
  tabBills: 'Billing',
  modalAccountingGroupTitle: 'Accounting Group',
  inputModalDefaultVal: 'Any',
  modalParentGlobalTitle: 'Global Customer Number',
  accountingModalInputText: 'Accounting Group Name Contains',
  // Customer Info Tab
  accountGroup: 'Accounting Group',
  industry: 'Industry:',
  division: 'Division:',
  currency: 'Currency:',
  corporateCustomer: 'Corporate Customer',
  globalCustomer: 'Global Customer',
  billToCustomer: 'Bill to Customer',
  soldToCustomer: 'Sold to Customer',
  streetAddress: 'Street Address:',
  city: 'City:',
  state: 'State:',
  country: 'Country:',
  phone: 'Phone:',
  fax: 'Fax:',
  ext: 'Ext.:',
  addressCardTitle: 'Address',
  generalInfoCardTitle: 'General Info',
  nameContains: 'Name Contains',
  parentGlobalCustomerNo: 'Parent Global Customer No.',
  globalCustomerNo: 'Global Customer Number',
  name: 'Name',
  mainContract: 'Main Contract',
  mainContractStatus: 'Main Contract Status',
  customerType: 'Customer Type',
  globalEntitlment: 'Global Entitlement',
  entitlementUnsupported: 'Entitlement Unsupported',
  serialized: 'Serialized',
  hideCustomerDetails: 'HIDE CUSTOMER DETAILS',
  showCustomerDetails: 'SHOW CUSTOMER DETAILS',
  active: 'Active',
  enterCustomerNo: 'Enter Customer No.',
  effectiveDate: 'Effective Date',

  customerNumber: 'Customer Number',
  globalCustomerNumberAndName: 'Global Customer Number and Name',
  globalCustomerNumber: 'Global Customer Number',
  globalCustomerName: 'Global Customer Name',
  customerName: 'Customer Name',
  modalAddNoteTitle: 'Customer Note',
  customerNoteAdded: 'Customer note added successfully',
  customerNoteUpdated: 'Customer note updated successfully',
  customerNoteDeleted: 'Customer note deleted successfully',
  customerNoteNotAdded: 'Customer note not added',
  customerNoteNotUpdated: 'Customer note not updated',
  customerNoteNotDeleted: 'Customer note not deleted',

  alertMessage: 'Are you sure you want to delete?',
  date: 'Date',
  time: 'Time',
  userName: 'User Name',
  noteTypeLabel: 'Note Type',
  note: 'Note',
  comment: 'Comment',
  orderNumberContains: 'Order Number Contains',
  ncrSiteIdContains: 'NCR Site ID Contains',
  importDate: 'Import Date',
  orderNumber: 'Order Number',
  ncrSiteId: 'NCR Site ID',
  siteName: 'Site Name',
  quantity: 'Quantity',
  totalPrice: 'Total Price',

  defaultSearchStatus: 1,
  defaultSearchEffectiveate: '',
  searchEffectiveDateLabel: 'Effective Date',
  entitlementSummaryLabel: 'Entitlement Summary for this Customer',
  totalEntitlementRecordLabel: 'Total Entitlement Summary found: ',
  customerEntitlementSummarySendEmail: 'Additional Email To (separate with , or ;)',
  customerEntitlementSummarySendEmailExample: 'ex1@mail.com, ex2@mail.com',
  customerEntitlementSummarySendEmailErrorMsg: 'Please enter valid email addresses separated by commas or semicolons.',

  totalSitesRecordLabel: 'Total sites for customers : ',
  customerSiteLabel: 'Site for Customer',
  administratorRole: 'Administrator',
  enterCustomerNumber: 'Please enter Customer Number.',
  numberOfSite: '(Number of Sites)',
  updatedSucessfully: 'Customer details has been updated successfully',
  notUpdatedSucessfully: 'Customer details has not been updated successfully',
};

export const ERP_SALES_ORDER = {
  enterOrderNumberNew: 'Please enter Order Number',
  search: {
    ORDER_NUMBER: 'ORDER_NUMBER',
    ORDER_NUMBER_SEARCH: 'ORDER_NUMBER_SEARCH',
  },
  DISPLAY_TYPE: {
    FAST_SEARCH: 'FAST_SEARCH',
    CREATE_UPDATE: 'CREATE_UPDATE',
  },

  MANUAL_ORDER_URL: '/entitlement/ErpSalesOrder/manual',
  RETRIEVE_ORDER_URL: '/entitlement/ErpSalesOrder',
  ERP_SALES_ORDER_STAGING_URL: '/entitlement/ErpSalesOrder/staging',
  accountingGroup: 'Accounting Group',
  accountGroup: 'Accounting Group',
  initialSelectValueForAny: 'Any',
  title: 'ERP Sales orders - staging',
  titleErp: 'ERP Sales orders',
  ANY: 'Any',
  ANY_VALUE: 'a',
  YES: 'Yes',
  YES_VALUE: 'y',
  NO_VALUE: 'n',
  COMPLETE: '<>',
  dropDownDefaultValueForYes: 'y',
  radioButtonWithMultipleFilters: 'Search with Multiple Filters',
  radioButtonWithGlobalCustomerNo: 'Search with Global Customer No.',
  displayTitle: 'Bill to Customer',
  tabInfo: 'Info',
  tabCustomerHistory: 'Customer History',
  tabSites: 'Sites',
  tabEntitlementsSummary: 'Entitlements Summary',
  tabSalesOrders: 'Sales Orders',
  tabChildren: 'Children',
  tabNotes: 'Notes',
  tabBills: 'Bills',
  modalAccountingGroupTitle: 'Accounting Group',
  inputModalDefaultVal: 'Any',
  modalParentGlobalTitle: 'Parent Global Customer No.',
  modalSiteTitle: 'Site Name',
  updatedSiteTitle: 'NCR Site Id',
  // Info Tab
  orderNo: 'Order No.',
  typeImportReady: 'Type Import Ready',
  orderType: 'Order Type',
  industry: 'Industry:',
  division: 'Division:',
  currency: 'Currency:',
  corporateCustomer: 'Corporate Customer',
  billToCustomer: 'Bill to Customer',
  streetAddress: 'Street Address:',
  city: 'City:',
  state: 'State:',
  country: 'Country:',
  phone: 'Phone:',
  fax: 'Fax:',
  ext: 'Ext:',
  addressCardTitle: 'Address',
  generalInfoCardTitle: 'General Info',
  nameContains: 'Name Contains',
  parentGlobalCustomerNo: 'Parent Global Customer No.',
  orderNumber: 'Order Number',
  name: 'Name',
  mainContract: 'Main Contract',
  mainContractStatus: 'Main Contract Status',
  customerType: 'Customer Type',
  globalEntitlment: 'Global Entitlement',
  entitlementUnsupported: 'Entitlement Unsupported',
  serialized: 'Serialized',
  hideCustomerDetails: 'HIDE CUSTOMER DETAILS',
  showCustomerDetails: 'SHOW CUSTOMER DETAILS',
  active: 'Active',
  enterOrderNumber: 'Enter Order Number for search...',
  importStatus: 'Import Status',
  accountingModalInputText: 'Accounting Group Name Contains',
  SITE_NAME_CONTAINER: 'Site Name Contains',
  SITE_NUMBER_STARTS_WITH: 'Site Number Starts with',
  SITE_TYPE: 'Site Type',
  ACTIVE: 'Active',
  CORPORATE_CUSTOMER: 'Global Customer',
  BILL_TO_CUSTOMER: 'Bill To Customer',
  dropDownDefaultValueForAny: 'a',
  globalCustomerNo: 'Global Customer Number',
  customerNumber: 'Customer Number',
  globalCustomer: 'Global Customer',
  TYPES: [
    { value: 0, label: 'Any' },
    { value: 1, label: 'Site' },
    { value: 2, label: 'Lab' },
    { value: 3, label: 'Technician' },
    { value: 4, label: 'Warehouse' },
    { value: 5, label: 'Corporate site' },
    { value: 6, label: 'Support stock' },
    { value: 7, label: 'Regional office' },
    { value: 8, label: 'Ae.com' },
    { value: 9, label: 'Rental site' },
  ],
  radioButtonWithProductCode: 'Search with Product Code',
  zeroValue: 0,
  aValue: 'a',
  recordCount: 25,
  yCap: 'Y',
  nCap: 'N',
  searchButton: 'Search',
  enter: 'Enter',
  server: 'server',
  doNotFound: 'Data not found for',
  itemTab: 'Items',
  entitlementSummary: 'Entitlement Summary',
  addLineItem: 'Add Line item',
  orderGroup: 'Order Group',
  customerNameColumn: 'Customer Name',
  customerIdColumn: 'Customer Id',
  ncrSiteIdCol: 'Site Id',
  siteNameCol: 'Site Name',
  siteNumberCol: 'Site Number',
  customerCol: 'Customer',
  orderNoCol: 'Order No.',
  importdateCol: 'Import Date',
  globalCustomerCol: 'Global Customer No.',
  updatedGlobalCust: 'Customer Number',
  customerNameCol: 'Customer Name',
  orderGroupCol: 'Order Group',
  summaryPageTitle: 'Entitlement summary for this Sales Order',
  items: 'Items',
  hardwareClass: 'Hardware Class',
  serviceProductCode: 'Service Product Code',
  serviceProductName: 'Service Product Name',
  serviceProductLevel: 'Service Level',
  quantity: 'Qty',
  salesProductModalTitle: 'Sales Product',
  qualifyLabel: 'All sales order items must qualify',
};

export const ERP_MANUAL_ORDER = {
  search: {
    ORDER_NUMBER: 'ORDER_NUMBER',
    ORDER_NUMBER_SEARCH: 'ORDER_NUMBER_SEARCH',
  },
  FIELD_LABELS: {
    ORDER_NUMBER: 'Order No',
    ORDER_GROUP: 'Order Group',
    GLOBAL_CUSTOMER_NUMBER: 'Global Customer No.',
    CUSTOMER_NAME: 'Customer Name',
    CUSTOMER_NUMBER: 'Customer Number',
    NCR_ID: 'NCR Site ID',
    SITE_NAME: 'Site Name',
    IMPORT_DATE: 'Import Date',
    COMMENT: 'Comment',
  },
  SITE_SEARCH_OPTION: 'Site Search Options',
  SALES_ORDER_URL: '/entitlement/ErpSalesOrder',
  SALES_ORDER_URL_RETRIEVE: '/entitlement/ErpSalesOrder',
  SALES_ORDER_STAGING: '/entitlement/ErpSalesOrder/staging',
  title: 'Display / Update ERP Sales orders',
  ANY: 'Any',
  ANY_VALUE: 'a',
  dropDownDefaultValueForYes: 'y',
  radioButtonWithMultipleFilters: 'Search with Multiple Filters',
  radioButtonWithGlobalCustomerNo: 'Search with Global Customer No.',
  displayTitle: 'Bill to Customer',
  tabInfo: 'Info',
  tabCustomerHistory: 'Customer History',
  tabSites: 'Sites',
  tabEntitlementsSummary: 'Entitlements Summary',
  tabSalesOrders: 'Sales Orders',
  tabChildren: 'Children',
  tabNotes: 'Notes',
  tabBills: 'Bills',
  modalAccountingGroupTitle: 'Accounting Group',
  inputModalDefaultVal: 'Any',
  modalParentGlobalTitle: 'Parent Global Customer No.',

  // Info Tab
  orderNo: 'Order No.',
  typeImportReady: 'Type Import Ready',
  orderType: 'Order Type',
  industry: 'Industry:',
  division: 'Division:',
  currency: 'Currency:',
  corporateCustomer: 'Corporate Customer',
  billToCustomer: 'Bill to Customer',
  streetAddress: 'Street Address:',
  city: 'City:',
  state: 'State:',
  country: 'Country:',
  phone: 'Phone:',
  fax: 'Fax:',
  ext: 'Ext:',
  addressCardTitle: 'Address',
  generalInfoCardTitle: 'General Info',
  nameContains: 'Name Contains',
  parentGlobalCustomerNo: 'Parent Global Customer No.',
  orderNumber: 'Order Number',
  name: 'Name',
  mainContract: 'Main Contract',
  mainContractStatus: 'Main Contract Status',
  customerType: 'Customer Type',
  globalEntitlment: 'Global Entitlement',
  entitlementUnsupported: 'Entitlement Unsupported',
  serialized: 'Serialized',
  hideCustomerDetails: 'HIDE CUSTOMER DETAILS',
  showCustomerDetails: 'SHOW CUSTOMER DETAILS',
  active: 'Active',
  enterOrderNumber: 'Enter Order Number for search...',
  itemTab: {
    addLineItem: 'Add Line Item',
  },
  manaulOrderSaveMsg: 'Record Successfully updated for Sales Order Number: ',
  createdManaulOrderSaveMsg:
    'Record Successfully created for Sales Order Number: ',
  MPONotGetting: 'Error while getting MPO order.',
  MPONotCreated: 'Error while creating MPO order.',
  customerNameRequired: "Please fill required field 'Customer Name'.",
  siteNameRequired: "Please fill required field 'Site Name'.",
  orderCreatedPopup: 'MPO created with Order Number: ',
  addLineItemPopup: "You have to save MPO before 'Add Line Item'.",
};

export const SWITCH_VALUE = {
  yes: 'y',
  no: 'n',
  Yes: 'Yes',
  No: 'No',
  blank: ' ',
};

export const SALES_MAPPING_DATA = {
  serviceProductModaltitle: 'Service Product',
  salesProductModaltitle: 'Sales Product',
  productCodeContainsLabel: 'Product Code or Name Contains',
  nameContains: 'Name Contains',
  prodContains: 'Product Code Contains',
  productsModalTitle: 'Products',
  warningGlobalMessage:
    "The supplied product is marked as unsupported globally,it can't be added globally.",
  UNSUPPORTED_SERVICE_PRODUCT: 'Unsupported Service Products',
  additional: ' Additional Orderable Service Products',
  CONTRACT: 'contract',
  prodCode: 'Product Code Contains',
};

export const TABLE_VARIANT = {
  pagination: 'pagination',
  standard: 'standard',
  HIGHER_ORDER_CONTRACT: 'higherContract',
  CONTRACT: 'contract',
};

export const TABS_CONFIG = {
  disabledKeyCode: 9,
};

export const TOASTER_MESSAGE = {
  combinationExists: 'Cannot add this combination as it already exists',
  orderableSuccess: 'Orderable Data saved Successfully',
  salesOrderSuccess: 'Higher Order Contract for Sales Order saved Successfully',
  salesOrderOnFail: 'Error while saving Higher Order Contract',
  noDataToSave: 'No data to save',
  orderableLoading: 'Saving....',
  unexpectedError: 'Error while saving Orderable Data',
  cpiUpdate: 'CPI value updated for the country data successfully',
  contractCpiUpdate: 'CPI for contracts updated',
  alertSuccess: 'Product successfully inserted',
  messageAdd: 'Product already exists for the contract unsupported products.',
};

export const TOASTER_VARIANT = {
  success: 'success',
  error: 'error',
};

export const INPUT_VARIANT = {
  modalInput: 'modalInput',
  iconInput: 'iconInput',
  standard: 'standard',
};

export const NOTES_DATA = {
  notes: "You've not added any notes!",
  notesText: 'Please add a new note to the contract.',
  apiSuccessText: 'Note added successfully',
  addNotesHeading: 'Add Note',
  entitlementHeading: 'Add Entitlement Note',
  addHeaderNote: 'Add a Header Note',
  addLineNote: 'Add a Line Note',
};

export const GRID_HEIGHT = {
  default: '400px',
  priceClassTable: '434px',
};

export const API_RESPONSE_STATUS = {
  pending: 'pending',
  success: 'success',
  fail: 'fail',
};

export const TOASTER_SEVERITY = {
  error: 'error',
  success: 'success',
  warning: 'warning',
};

export const TAB_VARIANT = {
  outline: 'outline-tab',
  scrollable: 'scrollable',
  filledTab: 'filled-tab',
  oosItemTab: 'oosItems-tab',
  billingCustomer: 'billing-tab',
};

export const SCROLL_BUTTON = {
  auto: 'auto',
};

export const ERROR_MESSAGE = {
  globalError: 'Something went wrong',
};

export const ENTITLEMENT_DATA = {
  numMinVal: 0,
  title: 'Entitlements',
  quickSearchTitle: 'Quick Search',
  inputVariant: 'iconInput',
  inputVariantCustomIcon: 'customIconInput',
  radioButtonWithSingleFilter: 'Search with Entitlement ID.',
  hideEntitlementSearch: 'Hide Entitlements Details',
  showEntitlementSearch: ' Show Entitlements Details',
  entitlementSiteHistory: 'Site History',
  blankDate: 'Please Provide deactive date',
  blankTransferDate: 'Please Provide a transfer date',
  siteStartDateValidation:
    'The Transfer Date can not be before the current site start date.',
  futureTransferDate:
    'Transfer date can not be future date, click ok to continue',
  pastTransferDate: 'Transfer date can not be past date, click ok to continue',
  transferDataErrorMessage:
    'The entitlement is inactive as of date, you can not transfer inactive entitlements!',
  activeDateShouldBeCurrentDate:
    'The Activate Date should be current date, click OK to continue',
  effectiveDateShouldBeCurrentDate:
    'The Effective Date should be current and past date, click OK to continue',
  alreadyExistHIstory:
    'The Entitlement Id, Site Start Date and Effective Date should not be same.',

  effectiveDateCannotBeFuterDate:
    'The Effective Date should be current date or past date, click OK to continue',
  active: 1,
  inActive: 2,
  checkStatus: 'Inactive',
  futureDate:
    'The Deactivate date should be current or past date, click OK to continue',
  priceClassError:
    'Entitlement should be attached to contract and should have a price class, click OK to continue',
  addEntitlementTitle: 'Add Entitlement History Details',
  priceClassShouldBeAttached:
    'Contract information was not found. It is possible that price class was not found on the contact. Activate did not complete!',
  entitlementTabEntitlementDetails: 'Entitlement Details',
  entitlementTabProductHistory: 'Product History',
  entitlementTabEntitlementActivity: 'Entitlement Activity',
  entitlementTabWarrantyInfo: 'Warranty Info',
  entitlementTabShippingInfo: 'Shipping Info',
  entitlementTabNotes: 'Notes',
  entitlementTabContractHistory: 'Contract History',
  //Extitlements Search Options
  modalParentGlobalTitle: 'Customer Number',
  radioButtonWithMultipleFilters: 'Search with Multiple Filters',
  radioButtonWithGlobalCustomerNo: 'Search with Global Customer No.',
  nameContains: 'Name Contains',
  accountGroup: 'Accounting Group',
  initialSelectValueForAny: 'Any',
  globalCustomerNo: 'Global Customer Number',
  activeLabel: 'Active',
  globalCustomer: 'Global Customer?',
  billToCustomer: 'Bill to Customer?',
  inputModalDefaultVal: 'Any',
  inputAddEntitlementHistoryModalDefaultVal: 'Active',
  dropDownDefaultValueForAny: 'a',
  dropDownDefaultValueForYes: 'y',
  accountingModalInputText: 'Accounting Group Name Contains',
  customerName: 'Name',
  accountignGroup: 'Accounting Group',
  isActive: 'Active?',
  customerNumber: 'Customer Number',
  serviceProductModaltitle: 'Service Product',
  errorMsg: 'Unexpected error occurred',
  invalidDateMsg: 'To Date cannot be less than From Date',
  todateErrorMsg: 'invalidTo',
  modalSiteTitle: 'Site Name',
  productCodeContainsLabel: 'Product Code or Name Contains',
  siteNameLabel: 'Site Name Contains',
  //Entitlement Details - Site Activity Tab
  entitlementSiteActivityHeadingLine: 'Site Activity for this Entitlement Site',
  columnNames: {
    serviceProductGrid: {
      productCode: 'Product Code',
      productName: 'Product Name',
      productType: 'Product Type',
      isActive: 'Active?',
    },
    siteGrid: {
      siteName: 'Site Name',
      siteId: 'Site Id',
    },
    accountingGroupGrid: {
      accountingGroupName: 'Accounting Group',
      accountingGroupCode: 'Code',
      activeFlag: 'Active',
      resellerFlag: 'Reseller Group',
    },
    entitlementSearchGrid: {
      entitlementId: 'Entitlement ID',
      productCode: 'Product Code',
      serviceProductName: 'Product Name',
      serialNumber: 'Serial #',
      siteName: 'Site Name',
    },
  },
  tabNames: {
    entitlementDetails: 'Entitlement Details',
    productHistory: 'Product History',
    entitlementActivity: 'Billing Activity',
    warrantyInfo: 'Warranty Info',
    shippingInfo: 'Shipping Info',
    notes: 'Notes',
    contractHistory: 'Contract History',
    billing: 'Billing',
    cpi: 'CPI',
  },
  tempAddModal: {
    serviceLevel: 'Service Level',
    duration: 'Duration',
    startDate: 'Start Date',
    serviceProductId: 'Service Product',
    site: 'Site',
    entitlementId: 'Entitlement ID',
  },
  serviceProductModal: {
    serviceProductCode: 'Service Product Code Contains',
    enterName: 'Enter name...',
    productCode: 'Product Code',
    name: 'Name',
    productType: 'Product Type',
    active: 'Active',
  },
  activeStatus: 'Active',
  deleteStatus: 'Delete',
  inActiveStatus: 'Inactive',
  ServiceLevel: 'Service Level',
  delete: 'Delete',
  activeBtn: 'activeBtn',
  inactiveBtn: 'inactiveBtn',
  pendingBtn: 'pendingBtn',
  entitlementBillingActivityBillingGrid: {
    defaultCustomerBillId: 0,
    activityForThisEntitlement: 'Activity for this Entitlement',
  },
  enterEntitlementID: 'Please Enter Entitlement ID',
  VOYIX_OWNED: 'voyix owned',
};

export const SITES = {
  show: 'SHOW SITE DETAILS',
  hide: 'HIDE SITE DETAILS',
  STATES: {
    HOME: 'HOME',
    INFO: 'INFO',
    DETAIL: 'DETAIL',
  },
  INFO: {
    SITE_NAME: 'Site Name',
    SITE_ID: 'NCR Site ID',
    STATUS: 'Status',
    TYPE: 'Site Type',
    NUMBER: 'Site Number',
    EFFECTIVE_CONTRACT: 'Effective Contract',
    OPTION: 'Site Option',
    CONTRACT_TITLE: 'Contract/s for this Site',
    LEVEL: 'Level',
    CONTRACT: 'Contract',
  },
  FILTER: {
    SITE_NAME_CONTAINER: 'Site Name Contains',
    SITE_NUMBER_STARTS_WITH: 'Site Number Starts with',
    SITE_TYPE: 'Site Type',
    ACTIVE: 'Active',
    CORPORATE_CUSTOMER: 'Global Customer',
    BILL_TO_CUSTOMER: 'Bill To Customer',
    VOYIX_OWNED: 'Voyix Owned',
  },
  YES: 'Yes',
  YES_VALUE: 'y',
  ANY: 'Any',
  ANY_VALUE: 0,
  TITLE: 'Sites',
  TITLE_INFO: 'Site/Sold to Customer',
  TITLE_DETAIL: 'Site Activity',
  QUICK_SEARCH_PLACEHOLDER: 'Quick Search',
  SEARCH_VARIANT: 'iconInput',
  SITE_SEARCH_OPTION: 'SITE SEARCH OPTIONS',
  SEARCH_OPTION: 'SEARCH OPTIONS',
  SITE_PARTS_FOUND: 'Site Part List',
  SITE_TABS: {
    INFO: 'Info',
    ENTITLEMENTS_SUMMARY: 'Entitlement Summary',
    ENTITLEMENTS_DETAIL: 'Entitlement Detail',
    SITE_HISTORY: 'Site History',
    SITE_CONFIGURATION: 'Site Configuration',
    SALES_ORDERS: 'Sales Orders',
    SITE_ACTIVITY: 'Site Activity',
    NOTE: 'Notes',
    VANTIVE: 'Vantive',
  },
  HISTORY: {
    EFFECTIVE_DATE: 'Effective Date',
    ACTIVE: 'Active',
    SITE_ID: 'NCR Site ID',
    CUSTOMER_NUMBER: 'Customer Number',
    CUSTOMER_NAME: 'Customer Name',
    BILL_TO_CUSTOMER_NUMBER: 'Bill to Customer Number',
    BILL_TO_CUSTOMER_NAME: 'Bill to Customer Name',
  },
  NOTES: {
    DATE: 'Date',
    USER: 'User',
    NOTES: 'Notes',
  },
  VANTIVE: {
    PRODUCT: 'Product',
    SERVICE_LEVEL: 'Service Level',
    RESPONSE_TYPE: 'Response Type',
    SERVICE_TYPE: 'Service Type',
    WORK_ORDER_TYPE: 'Work Order Type',
    ACTIVE: 'Active',
    EID_COUNT: 'EID Count',
    PRODUCT_CODE_CONTAINS: 'Product Code Contains',
    EID_LOCKDOWN: 'Eid Lockdown',
    VOYIX_OWNED: 'Voyix Owned',
  },
  ORDER_NUMBER: 'Order Number',
  IMPORT_DATE: 'Import Date',
  SALES_ORDER_TYPE: 'Sales Order Type',
  DETAILS: {
    defaultStauts: 'Active',
    statusActiveId: 0, //use for Any
    totalSitesFoundMsg: 'Total Entitlements found: ',
    inputModalDefaultVal: 'Any',
    inputModalDefaultValue: 0,
    statusActiveIdNum: 1,
    anyDefaultVal: 0,
    eid_Lockdown: null, //use for Any
    voyix_Owned: null, //use for Any
  },
  SITEACTIVITYDETAIL: {
    SITE_ACTIVITYDETAIL_API_RESPONSE_TEXT: {
      success: 'Site Activity Details found successfully',
      error: 'Site Activity Details not found with given ID',
    },
    UPDATE_API_RESPONSE_TEXT: {
      error: 'Something went wrong while updating Site Activity Details',
      success: 'Site Activity Details updated successfully',
    },
  },
  SITE_DETAILS: {
    duration: [
      { value: 1, label: '1 Day' },
      { value: 2, label: '2 Day' },
      { value: 3, label: '3 Day' },
      { value: 4, label: '4 Day' },
      { value: 5, label: '5 Day' },
      { value: 6, label: '6 Day' },
      { value: 7, label: '7 Day' },
    ],
  },
  ALERT: {
    SEARCH: 'Please enter Site ID',
    PROMPT: 'Are you sure you want to close? Any unsaved data would be lost.',
    ToSAVE:
      'Are you sure you want to commit this site Activity for single Entitlement record?',
    ToSuccess:
      'This Site Acitvity is being processed in the background. You will recive an email when task is complete.',
    priceErrorFirst:
      'The destination site you selected either does not support the price class for Entitlement ID',
    priceErrorLast: 'or is not in an approved status.',
    siteOptionChangeAlertText:
      'Changing the Site Option for this Site will affect the fees and service levels for # active entitlements.',
    //siteOptionChangeToRentalAlertText:'Changing the Site Option to rental is not permitted.',
    siteOptionChangeJobAlertText:
      'A background job was submitted to update effected entitlements. You will receive an email notifying you when this job has completed.',
  },
  radioButtonWithMultipleFilters: 'Search with Multiple Filters',
  radioButtonWithSiteID: 'Search with Site ID.',
  SiteIDLable: 'Site ID',
  SiteIDPlaceLable: 'Enter Site ID',
  Toastmsg: 'Record Successfully updated for Site Id :',
  siteOptionChangeNoteText: 'Site Option changed: # -> $',
  rentalSiteOption: 6,
  noteTypeIdSiteOptionChange: 1,
  noSiteAlertMsg: 'No Data found for Site Id #',
  siteTypeRentalSite: 'rental site',
  RENTAL_SITE_OPTION: 'rental',
  error: 'Something went wrong',
  success: 'Successfully updated.',
};

//SETUP WARRANTY
export const WARRANTY_TEXT = {
  alert: 'Entered Warranty Part Number Is Not Valid.',
  alertFields: 'Please select any one option to search.',
  serialNumberAlert:
    'Serial number should contain minimum 4 characters to search.',
  serialNumberSelectAlert: 'Select a serial number from the list.',
  serialNumberNotFoundAlert:
    'Serial Number not found. Try another serial number.',
};

export const API_RESPONSE = {
  SUCCESS: 200,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  NO_CONTENT: 204,
};

export const ENTITLEMENT_SUMMARY_TEXT = {
  count: 'Total Site found: ',
  es: 'Entitlement Summary found for this Site: ',
  codeLabel: 'Service Product Code Contains',
  nameLabel: 'Service Product Name Contains',
  defaultStatusValue: 1,
  empty: 0,
  numeric: 10,
};
export const ENTITLEMENT_WARRANTY_TEXT = {
  warranty: 'Warranties',
  priceClassNotExist:
    "Either the Price Class doesn't exist on the customer level contact or the deferral is not established for the price class. You can't add or edit a warranty.",
  warrantyHistory: 'Warranty History',
  swapSerialNoAlert:
    'Are you sure you want to swap serial numbers with the selected entitlement?',
  addWarranty: 'Add Warranty',
  snSwap: 'S/N Swap',
  SwapTest: 'Serial Number Swap',
  serialNumberHistory: 'Serial Number History',
  entitlementWarrantyHistory: 'Entitlement Warranty History',
  entitlementStandardWarrantyHistory: 'Standard',
  checkWarning: 'Warning',
  checkTrue: 'True',
};

export const TAB = {
  varientFilledTab: 'filled-tab',
  outLineTab: 'outline-tab',
};

export const ENTITLEMENT_API_RESPONSE_TEXT = {
  fastfindfail: 'Entitlement not found with given ID',
};

export const CONTRACT_API_RESPONSE_TEXT = {
  fastfindfail: 'Contract not found with given ID',
};

export const OOS_CASES = {
  title: 'Out of Scope Cases',
  caseId: 'Case ID',
  RMA: 'RMA',
  workOrder: 'Work Order',
  multipleSearch: 'Multiple Search',
  quickSearch: 'Quick Search',
  dateResolved: 'Date Resolved',
  amount: 'Amount',
  status: 'Status',
  customer: 'Customer',
  site: 'Site',
  globCustomer: 'Global Customer',
  caseTypeLabel: 'HW/SW',
  oosSearchOptions: 'SEARCH OPTIONS',
  noOfSearch: 'Out-Of-Scope Cases:',
  found: 'found',
  oosCaseStatus: 'OOS Case Status',
  totalNoOfCases: 'Total No. of Cases',
  modalAccountingGroupTitle: 'Accounting Group',
  accountGroup: 'Accounting Group',
  initialSelectValueForAny: 'Any',
  nameContains: 'Name Contains',
  accountingModalInputText: 'Accounting Group Name Contains',
  code: 'Code',
  active: 'Active',
  resellerGroup: 'Reseller Group',
  displayTitle: 'Information of Case',
  oosItems: 'OOS Items',
  notes: 'Notes',
  hideCaseDetails: 'HIDE OUT OF SCOPE CASE DETAILS',
  showCaseDetails: 'SHOW OUT OF SCOPE CASE DETAILS',
  history: 'HISTORY',
  comment: 'COMMENT',
  comments: 'Comments',
  chargeCodeLabel: 'Charge Code',
  reviewStatus: 'Review Status',
  siteName: 'Site Name',
  caseType: 'Case Type',
  corporateCustomer: 'Corporate Customer',
  billToCustomer: 'Bill to Customer',
  resolution: 'Resolution',
  resolutionCode: 'Resolution Code',
  closedDate: 'Closed Date',
  resolutionDate: 'Resolution Date',
  resolvedBy: 'Resolved by',
  closedBy: 'Closed by',
  ipMinutes: 'IP Minutes',
  summaryTitle: 'Summary',
  effectiveDate: 'Effective Date',
  userName: 'User Name',
  calcUnits: 'Calc. Units',
  actualUnits: 'Actual Units',
  calcAmount: 'Calc. Amount',
  actualAmount: 'Actual Amount',
  currentStatus: 'Current Status',
  description: 'Description',
  dateEntered: 'Date Entered',
  type: 'Type',
  oosNotes: 'OOS NOTES',
  caseNotes: 'CASE NOTES',
  enterCaseIdError: 'Please enter a Case ID.',
  enterRMAError: 'Please enter a RMA.',
  enterWorkOrderError: 'Please enter a Work Order.',
  caseNotFound: 'Case not found for',
  initialValue: 0,
  oos: 'OutOfScope',
  case: 'CASE',
  customerName: 'Customer Name',
  serviceLevel: 'Service Level',
  oosItemComment: 'OOS Item Comment',
  partNumber: 'Part Number',
  partsDescription: 'Parts Description',
  shipToLine1: 'Ship To: Line 1',
  shipDate: 'Ship Date',
  shipToLine2: 'Line 2',
  shipTracking: 'Ship Tracking',
  city: 'City',
  state: 'State',
  receiptDate: 'Receipt Date',
  postalCode: 'Postal Code',
  receiptTracking: 'Receipt Tracking',
  failureReason: 'Failure Reason',
  returnAnalysis: 'Return Analysis',
  successMessage: 'Case data has been saved successfully',
  errorMessage: 'Case data has not been saved',
  manuallyAddedItemComment: 'Initial status for manually added item',
  pendingReview: 'Pending Review',
  invoiced: 'Invoiced',
  RMAinformation: 'RMA Information',
};

export const PLACEHOLDER_TEXT = {
  enterComment: 'Enter Comment...',
  enter: 'Enter',
  enterName: 'Enter name...',
  search: 'Search',
  any: 'Any',
  enterEntitlementID: 'Enter Entitlement ID',
};

export const NAVIGATE_PATH = {
  home: '/home',
  setupErpProduct: '/setup/ERPProducts',
  entitlementModule: '/entitlement/Entitlements',
  siteActivityDetails: '/entitlement/Sites/sitedetails',
  sites: '/entitlement/Sites',
  billToCustomer: '/entitlement/Customers',
  outOfScopeCases: '/entitlement/OutOfScopeCases',
  erpSalesOrder: '/entitlement/ErpSalesOrder',
  erpSalesOrderItems: '../ERPSalesOrderItems',
  MANUAL_ORDER_URL: '/entitlement/ErpSalesOrder/manual',
  RETRIEVE_ORDER_URL: '/entitlement/ErpSalesOrder',
  ERP_SALES_ORDER_STAGING_URL: '/entitlement/ErpSalesOrder/staging',
  emBillingToolTab: '/billing/BillingTool/EmBillingPage',
  eTrackApproval: '/etrack/quote-approval',
  eTrackExisting: '/etrack/existing-quotes',
  eTrackDetail: '/etrack/existing-quotes',
  eTrack: '/etrack',
  emBillingToolModule: '/billing/BillingTool',
  contracts: '/entitlement/Contracts',
  backToeTrack: '/eTrack',
};

export const CUSTOMER_SITES = {
  naviagteUrltoSite: '/entitlement/Sites/',
  naviagteUrlQueryParam: '?module=customer',
  statusYes: 'y',
  statusNo: 'n',
  siteNameContainsLable: 'Site Name Contains',
  nceSiteIdContainsLable: 'NCR Site ID Contains',
  siteTypeLable: 'Site Type',
  siteTypeValue: 1,
  effectiveDateLabel: 'Effective Date',
  activeLabel: 'Active',
  navigateToCustomer: '/entitlement/Customers',
  queryParamModule: 'module',
  queryParamValue: 'customer',
  ncrSiteID: 'Site Id',
  siteActive: 'Active?',
  siteBillTo: 'Bill To',
  siteShipTo: 'Ship To',
  siteDeliverTo: 'Deliver To',
};

export const USER_ID = {
  loggedInUserID: 42,
  loggedInUserName: 'Admin, RSIM',
  loggedInUserNamewithSpace: 'Admin RSIM',
};

export const SITE_TYPE_COLOR = {
  Site: 'green',
  Lab: 'green',
  Technician: 'green',
  Warehouse: 'green',
  'Corporate Site': 'blue',
  'Support Stock': 'green',
  'Regional Office': 'green',
  'AE.com': 'green',
  'Rental Site': 'red',
};

export const ENTITLEMENT_TYPE_COLOR = {
  Standard: 'blue',
  'Temp Add': 'blue',
  'Site Config': 'blue',
  Warehouse: 'blue',
  'Voyix Owned': 'red',
};

export const OOS_CASES_BATCH_UPDATE = {
  TITLE: 'Batch Update',
  GRID_SEARCH_COUNT: 'Out-Of-Scope Cases ',
  CASE_SEARCH: 'Case Search',
  CASE_UPDATE: 'Case Update',
  BACK_BUTTON: 'Back to Out of scope Cases',
  UPDATE_SELECTED: 'Update',
  REVIEW_STATUS: 'Review Status',
  CASE_TYPE: 'Case Type',
  RESOLUTION_CODE: 'Resolution Code',
  DATE_CREATED: 'Date Created',
  DATE_RESOLVED: 'Date Resolved',
  CHECK: 'Check All for Pages',
  UNCHECK: 'Uncheck All for Pages',
  UPDATE_ERROR_MESSAGE: 'Status has not been updated',
  UPDATE_MESSAGE:
    'Status has been updated successfully except for cases with invoice status',
};

export const ERP_SALES_ORDER_ITEMS_DATA = {
  //Page
  title: 'ERP Sales Order Items',
  displayTitle: 'Display/Update ERP Sales Order Item',
  //Tab
  tab1: 'Entitlement',
  //Search Options
  searchOption1: 'filtersSearchOptions',
  searchOption2: 'fastfindSearchOptions',
  //Validation Error
  invalidDateMsg: 'To Date cannot be less than From Date',
  todateErrorMsg: 'invalidTo',
  fastfindSearchErrorMsg: 'Please enter all the required fields.',
  fastfindSearchNotFoundErrorMsg:
    'Invalid Order # / Line # / Ship Date combination.',
  //Search Options Labels
  shipDateLabel: 'Ship Date',
  importDateLabel: 'Import Date',
  salesProductLabel: 'Sales Product',
  masterCustomerNumberLabel: 'Master Customer Number',
  customerNameContainsLabel: 'Customer Name Contains',
  accountingGroupLabel: 'Accounting Group',
  importStatusLabel: 'Import Status',
  mappingTypeLabel: 'Mapping Type',
  orderGroupLabel: 'Order Group',
  orderNumberLabel: 'Order Number',
  lineNumberLabel: 'Line Number',
  //ERP Sales Order Search Grid Columns
  fieldOrderNumber: 'orderNumber',
  colOrderNUmber: 'Order Number',
  fieldShipDate: 'shipDate',
  colShipDate: 'Ship Date',
  fieldImportDate: 'importDate',
  colImportDate: 'Import Date',
  fieldCustomerName: 'customerName',
  colCustomerName: 'Customer Name',
  fieldSiteName: 'siteName',
  colSiteName: 'Site Name',
  fieldOrderGroup: 'orderGroup',
  colOrderGroup: 'Order Group',
  //Common
  errorMsg: '',
  inputModalDefaultVal: 'Any',
  unSupported: 'unsupported',
  //Modals
  modalAccountingGroupTitle: 'Accounting Group',
  modalMasterCustomerNumberTitle: 'Customer Number',
  modalSalesProductTitle: 'Sales Product',
  accountingModalInputText: 'Accounting Group Name Contains',
  productCodeContainsLabel: 'Product Code or Name Contains',
  salesProductModaltitle: 'Sales Product',
  initialSelectValueForAny: 'Any',
  globalCustomerNumber: 'Global Customer Number',
  activeLabel: 'Active',
  dropDownDefaultValueForAny: 'a',
  dropDownDefaultValueForYes: 'y',
  billToCustomer: 'Bill to Customer?',
  globalCustomer: 'Global Customer?',
  importPendingStatus: 'Pending',
  importCompletedStatus: 'complete',
  addLineItem: 'Add Line Item',
  importStatusID: 1,
  mappingTypeId: 2,
  duplicateProductCode: 'Duplicate sales product code selected.',
  addLineItemModalTitle: 'Add Line Item',
  entitlementID: 'Entitlement ID',
  serviceProductCode: 'Service Product Code',
  serviceProductName: 'Service Product Name',
  voyixOwned: 'Voyix Owned',
  shipSerial: 'Ship Serial #',
  currentSerial: 'Current Serial #',
  entitlementGridTitle: 'Entitlement(s) Created from this Sales Order Item',
  createEntitlementRequested:
    'Entitlement creation has been requested on this order',
  mappingType: {
    Unsupported: 1,
    Single: 2,
    ServiceGroup: 3,
    Exception: 4,
    OnHold: 5,
  },
  importStatus: {
    Pending: 1,
    InProcess: 2,
    Complete: 3,
    Failed: 4,
    OnHold: 5,
  },
  createEntitlementAlert:
    'This item has been submitted to be processed. Check back in a few minutes to see that it has been processed.',
};

export const ERP_SALES_ORDER_ITEMS_API_RESPONSE_TEXT = {
  fastfindfail: 'Invalid Order # / Line # / Ship Date combination.',
  unsupportedUpdate: 'Sales Order Item is saved successfully.',
  unsupportedNotUpdate: 'Sales Order Item is not saved successfully.',
};

export const COPY_PRICE_SHEET_API_RESPONSE_TEXT = {
  copyPriceSheet: 'PriceSheet copied successfully.',
  failedCopyPriceSheet:
    'Something went wrong while copieng Price Sheet. Please try again.',
};

export const GENERAL_LABLE = {
  transferLable: 'Transfer',
  anyLable: 'Any',
  updatedAny: 'ANY',
};

export const SLICE_NAME = {
  warrantyInfo: 'warrantyInfo',
};

export const ETRACK_DATA = {
  yesVal: 'y',
  noVal: 'n',
  quotesTitle: 'Quotes',
  numMinVal: 0,
  title: 'Current Customer',
  quickSearchTitle: 'Enter Customer ID',
  inputVariant: 'iconInput',
  hideEtrackSearch: 'Quote Search Options',
  showEtrackSearch: ' Quote Search Options',
  checkShowOnly: "Show only item that aren't unassigned",
  items: 'Items',
  serialNumber: 'Serial Number',
  serviceModal: 'Service Model',
  siteNameContains: 'Site Name Contains',
  siteName: 'Site Name',
  orderNumber: 'Order Number',
  quoteNumber: 'Quote Number',
  noOfSearch: 'No. of Search:',
  ANY: 'Any',
  ANY_VALUE: 0,
  CONTRACT: 'contract',
  ITEMSTYPE: [
    { value: 0, label: 'Any' },
    { value: 1, label: 'Are Unassigned' },
    { value: 2, label: 'Have Expired' },
    { value: 3, label: 'Have not Expired' },
    { value: 4, label: 'Expired in 30 days' },
    { value: 5, label: 'Expired in 60 days' },
    { value: 6, label: 'Expired in 90 days' },
    { value: 7, label: 'Expired in 120 days' },
  ],

  ITEMSQUOTETYPE: [
    { value: 0, label: 'Any' },
    { value: 1, label: 'Upgrade/Move Warranties' },
    { value: 2, label: 'Move Hardware' },
    { value: 3, label: 'Cancel Warranties' },
  ],

  search: 'Search',
  found: 'found',
  quoteItem: 'Items for Quote',
  alreadyOnQuote: 'This equipment is already on a quote',
  inActiveOnQuote: 'This equipment has reached end of service as of end date.',
  pricingExistingMsg:
    'There is no pricing for this, please contact your Client Service Manager',
  rentleFlagMsg: 'Rental equipment',
  serviceNameLabel: 'Service Name Contains',
  defaultETrackQuoteType: 0,
  createQuoteAlert: 'You must select items to place on a quote first.',
  emptyQuoteTypeAlert: 'You must select quote type to create.',
  alertTextMessage: 'Something went wrong. Please try again.',
  deleteQuoteAlertMsg: 'Are you sure you wish to delete this quote?',
  //fetch Quote Status from API if needed
  quoteStatus: {
    quote: 1,
    expired: 2,
    submitted: 3,
    approvedHardwareEntitlements: 4,
    approvedBusinessCenter: 5,
    rejected: 6,
    completed: 7,
  },
  cancelWarrantyFlag: 'n', //required fro Create Quote
  warrantyDuration: 0, //required fro Create Quote,
  removedQuoteTypeId: 4, //Repair & Return
  removedQuoteTypeId1: 3, //Cancel Warranties
  submitQuoteAlertMsg:
    'By clicking OK you are submitting an order as per the terms of your agreement with NCR VOYIX.',
  submitQuoteEmailSubject1: 'NCR VOYIX eTrack Quote',
  submitQuoteEmailSubject2: 'Submitted for Approval.',
  submitQuoteModalTitle: 'Submit Quote',
  approveQuoteModalTitle: 'Approve Quote',
  approveQuoteAlertMsg:
    'By clicking OK you are submitting an order as per the terms of your agreement with NCR VOYIX.',
  ETRACK_API_RESPONSE_TEXT: {
    notFound: 'No search results found.',
    forID: 'ID.',
    error: 'error',
  },

  etrackInactive: 'Inactive',
  etrackN: 'n',
  hasBeenApproved: 'has been approved.',
  hasNotBeenApproved: 'has not been approved.',
  addItemModalTitle: 'eTrack',
  addItemSubmitConfirmText:
    'Are you sure you want to add the selected item(s)?',
  additemsModalFooterMessage1:
    'Items in red are missing in pricing. Items in blue are already on a quote. Items in darkgray have reached end of service. Items in orange are rental items.',
  additemsModalFooterMessage2:
    'These items are displayed for information purposes only, and cannot be modified. If you see this and believe it is in error, please contact your client service manager.',
  additemsModalFooterMessage3:
    'Note: Once a quote has been approved, there may be up to a 5 minute delay for the system to reflect the changes in the search data. We perform scheduled maintenance from 1 AM to 2 AM ET. During this time you may experience slower response times.',
  noChangeDropDownVal: '[No Change]',
  quotes: {
    type1: {
      id: 1,
      name: 'Upgrade/Move Warranties',
    },
    type2: {
      id: 2,
      name: 'Move Hardware',
    },
    type3: {
      id: 3,
      name: 'Cancel Warranties',
    },
  },
  updatedSelectedRecordsTitle: 'Updated Selected Records',
  updateOptionHeaderText: 'Option for the selected model',
  deleteSelectedItemAlert: 'Are you sure you want to remove this item?',
  deleteSelectedItemsAlert: 'Are you sure you want to remove these _ items?',
  noEntitlementAlert: 'At least one Entitlement must be selected.',
  removeAlertRestrictMessage:
    'You cannot edit a quote once it has been submitted!',
  removeAlertMessage:
    'This will remove all product listed matching this model. Do you wish to continue?',
  extendedWarrantyOptions: [
    { value: 0, name: '0 Years' },
    { value: 1, name: '1 Year' },
    { value: 2, name: '2 Years' },
    { value: 3, name: '3 Years' },
    { value: 4, name: '4 Years' },
    { value: 5, name: '5 Years' },
    { value: 6, name: '6 Years' },
  ],
  siteTypeData: [{ id: 0, name: '[Any]' }],
  siteActiveData: [
    { id: 'a', name: '[Any]' },
    { id: 'n', name: 'No' },
    { id: 'y', name: 'Yes' },
  ],
  noUpdateAlertMessage:
    'You have made changes to the update boxes at the bottom, but have not committed those changes by clicking update. Please either click update or reset before Saving/Submitting the quote.',
  serviceLevelSameAlert:
    'All Service Levels for a single Model at a single Site must be the same.',
  existQuoteItemAlert:
    'At least one of the records you have selected has been added to a quote since you selected it. Please remove them from the quote before proceeding.',
  existQuoteItemOnAnotherQuoteAlert:
    'At least one of the item you have added on the quote has been added to another quote (Quote: $). Please verify and remove them from the quote before proceeding.',
  serviceLevelUpdateAlert:
    'When updating the Service Level, you can only update items of the same model at the same time.  Please update your selections and try again.',
  siteSyncCommentText: 'Site Sync',
  siteSyncNoEntitlement:
    'The site you selected does not have any eligible entitlement assigned to it. Please select a different site.',
  siteSyncExistQuoteItems:
    'The site you selected has entitlement assigned to a quote. Please select a different site.',
  siteNoCloseAlertText: 'You must select a site to continue or cancel to exit.',
  warrantyEndDateAlert: 'You cannot sync to a date before ',
  quoteANY: 'Select Quote Type',
  quoteANY_VALUE: 0,
  etrackWarrantyEndDateAlertMsgCheck: 'You cannot sync to a date after',
  etrackWarrantyEndDateAlertMsg:
    'You cannot sync to a date after # due to model $ having and end of service date. Please contact your Client Service Manager if you have any questions.',
  etrackWarrantyEndExtendAlert:
    "You cannot extend model # because it will extend it beyond the model's end of service date. Please contact your Client Service Manager if you have any questions.",
  etrackWarrantyEndExtendAlertCheck: 'You cannot extend model',
  inactiveQuoteStatusId: 2,
  activeQuoteStatusId: 1,
  corporateSiteTypeId: 5,
  traditionalSiteTypeId: 1,
  supportStockSiteTypeId: 6,
  siteNotallowedToTransferMsgText:
    'Please assign quote to a non-corporate site.',
  nonCustomerMappingAlertMessage: 'MCN mapping is missing for this account. Please contact your Client Service Manager.',
};

export const ETRACK = {
  QUOTE_NO: 'Quote Number',
  SEARCH_VARIANT: 'iconInput',
  QUICK_SEARCH: 'Quick Search',
  quoteNumberPlaceHolderText: 'Enter Quote Number',
  EMPTY_QUOTE: 'Please enter Quote Number',
  DATA_NOT_FOUND: 'Data not found for',
  QUOTE_SEARCH_OPTION: 'QUOTE SEARCH OPTIONS',
  FILTER: {
    LAST_UPDATED: 'Last Updated',
    CREATED_DATE: 'Created Date',
    APPROVED_DATE: 'Approved Date',
    GLOBAL_CUSTOMER_CODE: 'Global Customer Code',
    GLOBAL_CUSTOMER_NUMBER: 'Global Customer Number',
    BILL_TO_CUSTOMER: 'Bill To Customer',
  },
  CHECKBOX: ['Quote', 'Submitted', 'Approved', 'Completed', 'Expired'],
  DETAIL: {
    CREATE_QUOTE: 'Create Quote',
  },
  QUOTE_TABS: {
    DETAILS: 'Details',
    HISTORY: 'History',
  },
  CURRENT_CUSTOMER: 'Current Customer',
  STATUS: 'Status',
  QUOTE: 'Quote',
  TYPE: 'Type',
  CUSTOMER_REF: 'Customer Ref / PO#',
  EFFECTIVE_DATE: 'Effective Date',
  CREATED_BY: 'Created by',
  DATE_CREATED: 'Date Created',
  LAST_MODIFIED_BY: 'Last Modified By',
  LAST_DATE_MODIFIED: 'Last Date Modified',
  DESCRIPTION: 'Description',
  SELECT: 'Select',
  upgradeMoveWarrantiesId: 1,
  moveHardwareId: 2,
  cancelWarranties: 3,
  automatedApproval_HWE: 'Automated Approval By HWE',
  automatedApprovalBC_WUM: 'Automated Approval By BC - Warranty Upgrade/Move',
  automatedResetToQuote:
    'Automated Reset to Quote Status due to Rejected Status',
  quoteRejected: 'Quote Rejected Successfully!',
  quoteApproved: 'Quote Approved Successfully!',
  quoteStatus_Quote: 1,
  quoteStatus_Expired: 2,
  quoteStatus_Submitted: 3,
  quoteStatus_ApprovedHWE: 4,
  quoteStatus_ApprovedBC: 5,
  quoteStatus_Rejected: 6,
  quoteStatus_Completed: 7,
  eTrackOriginCreate: 'createquote',
  eTrackOriginExist: 'existingquote',
  eTrackOriginApprove: 'approvequote',
  quoteTypes: {
    moveHardware: 'Move Hardware',
    upgradeMoveWarranties: 'Upgrade/Move Warranties',
    cancelWarranties: 'Cancel Warranties',
  },
  mncErrorMessage: 'Please Select MCN',
  modalTitle: 'Select MCN',
};

export const ETRACK_APPROVAL = {
  TITLE: 'eTrack Quote Approval Queue',
  REFRESH_QUEUE: 'Refresh Queue',
  SUBMISSION_QUEUE: 'Submission Queue',
  GLOBAL_CUSTOMER_NUMBER: 'Global Customer Number',
  ACCOUNTING_GROUPS: 'Accounting Groups',
  SEARCH_OPTION: 'SEARCH OPTIONS',
  QUOTES_AWAITING_APPROVAL: 'Quotes awaiting approval',
  SELECT: 'Select',
  QUOTE_TABS: {
    ENTITLEMENT: 'Entitlement',
    HISTORY: 'History',
  },
  ENTITLEMENT_TABS: {
    SITE: 'SITE',
    FEES: 'FEES',
  },
  QUOTE: 'Quote',
  SUBMITTED_BY: 'Submitted by',
  TYPE: 'Quote Type',
  CUSTOMER_NAME: 'Customer Name',
  DATE_SUBMITTED: 'Date Submitted',
  PRODUCT_BEING_CHANGED: 'Product Being Changed',
  SITE_NAME: 'Site Name',
  SITE_TYPE: 'Site Type',
  SERVICE_LEVEL: 'Service Level',
  SERVICE_PRICE_LEVEL: 'Service Price Level',
};

export const WARRANTY_INFO_TAB = {
  effectiveDate: 'effectiveDate',
  effectiveDateHeader: 'Effective Date',
  serialNumber: 'serialNumber',
  serialNoHeader: 'Serial No.',
  modelName: 'modelName',
  modelNameHeader: 'Model',
  submodelName: 'submodelName',
  subModelNameHeader: 'Submodel',
  entitlementId: 'entitlementId',
  entitlementIdHeader: 'Entitlement',
  warrantyPartNumber: 'warrantyPartNumber',
  wpnHeader: 'RQS ID',
  serialNo: 'serialNo',
  subModelName: 'subModelName',
};

export const BILLING = {
  billingHeader: 'Billing',
  billingTool: {
    billingToolTab: {
      bill: 'BOC Export',
      details: 'Details',
      billNotes: 'Bill Notes',
      history: 'History',
      popupMessage:
        'The contract for this customer is currently in CREATE status. Changes that could effect this bill may be in the process of being made.',
      flagStatus: 'y',
      createStatus: 'Create',
      approvedStatus: 'Approved',
    },
    billSliceName: 'billingTool',
    historyGrid: {
      lastModifiedTimestamp: 'lastModifiedTimestamp',
      date: 'Date',
      userName: 'userName',
      user: 'User',
      billStatusName: 'billStatusName',
      status: 'Status',
    },
  },
  emBillingSearch: {
    accountingGroup: 'Accounting Group',
    customer: 'Customer Number',
    globalCustomer: 'Global Customer Number',
    billStatus: 'Bill Status',
    billgenerationDate: 'Bill Generation Date',
    billStartEndDate: 'Bill Start / End Date',
    emBilling: 'EM Billing',
    Generated_Bills_awaiting_review: 'Generated Bills Awaiting Review',
    earliestDate: 'Earliest Effective Date',
    lastEffectiveDate: 'Last Effective Date',
    numEntitlement: '# of Entitlement',
    totalFees: 'Total Fees',
    status: 'Status',
    statusIsNotAvailable: 'Status is not Available',
    custColumn: 'Customer Name',
    globalCustomerName: 'Global Customer Name',
    billStartDate: 'Bill Start Date',
    billEndDate: 'Bill End Date',
    alertMessage: 'Please select the Row.',
    statusIdForOne: 1, //Waiting for Approval
    statusIdForTwo: 2, //Approved to be Billed
    statusIdForZero: 0, // for any
    statusId: 2,
    approveToBillMsg:
      'Entries in Waiting for Approval status are changed to Approved to be billed status',
    waitingToReturnMsg:
      'Entries in Approved to be Billed status are changed to Waiting for Approval',
    billedMsg: 'Entries in Approved to be Billed status are changed to Billed',
    anyMsg: 'Success',
    errorMsg: 'Error',
    billStatusId: 3,
  },

  waitingForApproval: 'Waiting for Approval',
  approvedToBilled: 'Approved to be Billed',
  billed: 'Billed',
  billingDetailsTab: {
    eId: 'EID',
    billId: 'Bill ID',
    gcn: 'GCN',
    billGenetationDate: 'Bill Generation Date',
    billToSiteId: 'Bill To Site ID',
    gCustomerName: 'GLOBAL CUSTOMER NAME',
    mcn: 'MCN',
    customerName: 'CUSTOMER NAME',
    ncrSiteId: 'NCR SITE IDE',
    siteName: 'SITE NAME',
    storeNbr: 'STORE NBR',
    pId: 'PID',
    pIdDescription: 'PID DESCRIPTION',
    priceClass: 'PRICE CLASS',
    serviceLevel: 'Service Level',
    billingPriodStart: 'Billing period Start',
    billingPeriodEnd: 'Billing period End',
    rate: 'Rate',
    rateSource: 'Rate Source',
    pricingOption: 'PRICING OPTION',
    totalFee: 'Total Fee',
  },

  checkCount: 50,
  threeDot: '...',
  initialValue: 0,
};

export const CONTRACT_GRID_LABEL = {
  date: 'Date',
  contractId: 'Contract ID',
  contract: 'Contract',
  userName: 'User Name',
  note: 'Note',
  contractType: 'Contract Type',
};

export const CPISETUP = {
  cpiSetup: 'cpiSetup',
  cpiPercentage: '0.00 %',
  cpiSetupHeader: 'CPI Setup',
};

export const CPI_SETUP_HISTORY_COLUMN = {
  EFFECTIVE_DATE: 'Effective Date',
  CPI: 'CPI',
  LOCKED_DOWN: 'Locked Down',
  COMPLETED: 'Completed',
  APPLIED_BY: 'Applied By',
};

export const ADMIN_SCREEN_ROLE = {
  featureTitle: [
    { id: 0, name: 'EMSetup', value: 'Entitlement Setup' },
    { id: 1, name: 'ContractManagement', value: 'Contract Management' },
    { id: 2, name: 'EntitlementManagement', value: 'Entitlement Management' },
    { id: 3, name: 'Billing', value: 'Billing' },
    { id: 4, name: 'OOS', value: 'Out-of-Scope Cases' },
    { id: 5, name: 'eTrackCustomer', value: 'e-Track Customer Interface' },
    { id: 6, name: 'eTrackInternal', value: 'e-Track Internal Interface' },
  ],
  permissions: [
    {
      name: 'Create',
      key: 'canCreate',
    },
    {
      name: 'Delete',
      key: 'canDelete',
    },
    {
      name: 'Edit',
      key: 'canEdit',
    },
    {
      name: 'Read-Only',
      key: 'isReadOnly',
    },
  ],

  useRoles: 'User Role',
  saveMessage: 'User Roles Based Acces Permissions have been Saved',
  userRoleBased: 'User Role Based Access Permission',
  eTrackUserMCNMappingTitle: 'eTrack Users',
};

export const CUSTOMERS_BILLING = {
  billingNotesTabCountText: 'Associated Bill Notes',
  billingBillsTabCountText: 'Bills for the Customer',
  popupMessage: 'You will be notified once the bill has been generated.',
  popupMessageNotFound: 'Data not found for the Customer',
};

export const E_BILLING_ACTIVITY_TAB = {
  columnCPI: {
    activeDate: 'Activity Date',
    info: 'Info',
    appliedBy: 'Applied By',
  },
  activityForThisEntitlement: 'Activity for this Entitlement',
};

export const ETRACK_API_MESSAGE = {
  deleteQuoteSuccess: 'Quote has been deleted successfully.',
  deleteQuoteError: 'Something went wrong while deleting the quote.',
  alreadyDeletedQuote: 'Quote has already been deleted.',
  saveQuoteSuccess: 'Quote has been saved successfully.',
  saveQuoteError: 'Something went wrong while saving the quote.',
  submitQuoteSuccess: 'Quote has been submitted successfully.',
  submitQuoteError: 'Something went wrong while submitting the quote.',
};

export const CURRENCY_CODE = {
  usa: 226,
};

export const CPI_SETUP = {
  goAlert:
    'The Date you have chosen already exists. Please select a different date.',
  resetAlert: 'Are you sure you want to reset the CPI table? ',
  goAlertText: 'The passed data is incorrect or already exists.',
  lockdownHeading: 'Lock Down CPI',
  lockdownwarning:
    'By clicking the lock down button,you will be locking the CPI tables so that no further changes can be made..The changes in the tables will be applied to the entitlement Management system on the date specified above.',
  removeAlert: 'Are you sure you want to remove selected contract id/s?',
  rangeAlert:
    ' The CPI entered is outside of the minimum and maximum range established for these contract(s) <Contract Name(s)>. The CPI amount was adjusted to fit within the range" ',
  valueForY: 'y',
  valueForN: 'n',
  cpiLockdown: 'CPI is currently locked down. No changes can be made.',
  prirortyNotification:
    'By clicking the Lock Down button, you will be locking the CPI tables so that no further changes can be made. The changes in the tables will be applied to the Entitlement Management System on the date specified above. OK to continue, Cancel to stop without locking down.',
  range1:
    'The CPI entered is outside of the minimum and maximum range established for these contract(s)',
  range2: 'The CPI amount was adjusted to fit within the range',
  selectAlert: 'Atleast one Contract must be selected.',
  deletedList:
    'Are you sure you want to update and hide the selected contract id/s?',
  updatedHeading: 'Update Selected',
  isActive: 'y',
  inActive: 'n',
  searchOptionsLabel: 'SEARCH OPTIONS',
  cpiCountry: 'country',
  cpiSetup: 'cpisetup',
  cpiAll: 'all',
  cpiContinueAlertMsg: 'Please fill in required field Default CPI.',
  cpiJobAlertMsg:
    'The next CPI has not been setup, Continuing will begin the setup. Click OK to continue, or Cancel to exit without beginning this setup.',
};

export const AUTH = {
  accessToken: 'accesstoken',
};

export const GLOBAL_MODAL = {
  nameBegins: ' Name Begins',
  search: 'Search',
  countryCode: 'Country Code Begins',
};

export const USER_TYPE = {
  internalUser: 'Internal',
  externalUser: 'External',
};

export const EOS = {
  alert:
    'A background job has been submitted to update effected entitlements end of service date. You will receive an email notifying you when this job has completed.',
  deleteAlertTitle:
    "Are you sure you want to remove this Exception? This will set all of the Contract's entitlements' End of Service dates to the Product's End of Service Date.",
  editDateAlert:
    "Are you sure you want to change 'End of Service Date' for contract",
};

export const COPY_EMAIL = {
  success: 'Requested email copy has been sent',
  fail: 'Error while sending requested copy of email',
};

export const featurePermission = {
  EMSetup: 1,
  ContractManagement: 2,
  EntitlementManagement: 3,
  Billing: 4,
  OOS: 5,
  eTrackCustomer: 6,
  eTrackInternal: 7,
};

export const defaultSpellValue = {
  checkFalse: false,
  checkTrue: true,
};

export const DATE_DISPLAY_FORMATS = {
  format1: 'MM/DD/YYYY',
  format2: 'MM/DD/YYYY | hh:mm:ss A',
  format3: 'MM/DD/YYYY hh:mm:ss A',
  format4: 'MM/dd/yyyy hh:mm:ss a',
  format5: 'MM/dd/yyyy',
  format6: 'EST',
  format7dash: 'ESTDASH',
  format8: 'YYYY-MM-DD',
  format9: 'MM/DD/YYYY HH:MM:ss A',
};

export const COMMENT = {
  siteStartDate: 'Site Start Date ',
  effectiveDate: 'Effective Date',
  newEnt: 'New Entitlement History Added',
  statusChanged: 'Status changed',
  currChanged: 'Currency changed',
  annualChanged: 'Annual Fee changed',
  slChanged: 'Service Level changed',
  newEntSiteStartDate: 'New Entitlement Site Start Date :',
  newWithZero: 'New Entitlement History Added [$0.00]',
};

export const MIN_MAX_DATES = {
  minDate: '1900-01-01',
  maxDate: '2099-12-31',
};

export const eTrackUser_Text = {
  searchWithLabel: 'Search with: First Name / Last Name / Email / User Name',
  userSearch: 'User Search',
  totalUserFound: 'Total eTrack Users found: ',
  eTrackUserHeading2: 'eTrack User Details',
  firstNameLabel: 'First Name',
  lastNameLabel: 'Last Name',
  emailLabel: 'Email',
  userNameLabel: 'User Name',
  MCNMappingDetails: 'MCN Mapping Details',
  addAlert: 'Customer already mapped',
  deleteAlert: 'Do you want to remove this MCN mapping ?',
};